const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase()

export default {
	//login home page
	loginHeader: {
		contactUs: 'اتصل بنا',
	},
	loginPage: {
		instructionstitle1: 'جميع أدوات التحكم',
		instructionstitle2: 'في حساباتك في',
		instructionstitle3: 'متناول يديك',
		options1f: 'الإيداع الفوري',
		options1l: 'في الحساب',
		options2f: 'التحويل ما بين',
		options2l: 'الحسابات',
		options3f: 'السحب السريع',
		options3l: '',
		termsAndConditions: 'الشروط والأحكام',
		privacyPolicy: 'سياسة الخصوصية',
		amlPolicy: 'سياسة مكافحة غسيل الاموال',
		refundPolicy: 'سياسات استرداد الأموال',
		riskDisclosure: 'إخلاء المسئولية',
		complaintsProcedure: 'إجراءات الشكاوى',
		cookiePolicy: 'سياسة ملفات الارتباط',
		userError:
			'كلمة المرور التي أدخلتها غير صحيحة. يرجى التحقق وإعادة المحاولة.',
		userErrorTwo:
			'البريد الإلكتروني الذي أدخلته غير مسجل معنا. برجاء إدخال بريد إلكتروني صحيح والمحاولة مرة أخرى',
		enterCodeBelow:
			'رجاء إدخال الرمز الذي حصلت عليه من تطبيق المصادقة في الخانات أدناه.',
		enterYourCode: 'أدخل رمز المصادقة الثنائية الخاص بك',
		authCode: 'رمز المصادقة',
		loginMobile: 'تسجيل الدخول لحسابك',
		loginOr: 'أو قم بتسجيل الدخول باستخدام بيانات اعتمادك:',
	},

	wellcomeComponent: {
		title: 'شكرا لاهتمامك بفتح حساب مع تريد فيو! فلنبدأ',
		titlesub: 'عملية فتح الحساب الآن',
		subTitle:
			'نقوم الآن بجمع بعض المعلومات اللازمة لإعداد حسابك والتحقق من هويتك.',
		before: 'قبل البدء، جهز الوثائق التالية:',
		government: '• هوية صادرة من جهة حكومية تحتوي على صورة شخصيه لك.',
		proof: '• إثبات محل الإقامة',
		signature: '• التوقيع الرقمي',
		agree:
			'*أوافق على السماح لشركة Tradeview Ltd بالتحقق من شخصيتي بصورة إلكترونية باستخدام معلوماتي الشخصية التي تتضمن اوراق الهوية الخاصة بي. سوف نقوم باستخدام أحد البرامج الآمنه للتحقق من الهوية و صحة المعلومات المقدمة من طرف العميل.',
		agreeLATAM:
			'*أوافق على السماح لشركة Tradeview Financial Markets S.A.C. بالتحقق من شخصيتي بصورة إلكترونية باستخدام معلوماتي الشخصية التي تتضمن اوراق الهوية الخاصة بي. سوف نقوم باستخدام أحد البرامج الآمنه للتحقق من الهوية و صحة المعلومات المقدمة من طرف العميل.',
		btnContinue: 'استمرار',
		btnGoBack: 'العودة إلى الخلف',
		btnConfirm: 'تأكيد',
		checkError: 'رجاء الضغط علي المربع للموافقة علي الأمر.',
	},

	loginBox: {
		title: 'تسجيل الدخول لحسابك',
		logInGoogle: 'التسجيل من خلال جوجل',
		logInFacebook: 'التسجيل من خلال فيسبوك',
		or: 'أو قم بتسجيل الدخول ببياناتك الخاصة:',
		email: 'البريد الإلكتروني',
		placeholderEmail: 'ادخل بريدك الإلكتروني',
		placeholderPassword: 'كلمة المرور',
		password: 'كلمة المرور',
		submit: 'استمرار',
		forgot: 'هل نسيت كلمة السر؟',
		doNotAccount: 'ليس لديك حساب؟',
		signUp: ' سجل الآن.',
		tryFreeDemo: 'جرب العرض التجريبي المجاني',
		remember: 'تذكرني',
		emailError: 'يرجى إدخال عنوان بريدك الإلكتروني',
		passwordError: 'يرجى إدخال كلمة المرور الخاصة بك',
		passwordToEmail: 'يرجى التحقق من بريدك الإلكتروني',
		passwordToEmailDesc: 'لقد أرسلنا لك كلمة مرور مؤقتة لإعادة تعيين حسابك.',
	},

	forgotPage: {
		instructionstitle1: 'جميع أدوات التحكم',
		instructionstitle2: 'في حساباتك في',
		instructionstitle3: 'متناول يديك',
		options1f: ' الإيداع الفوري',
		options1l: ' في الحساب',
		options2f: 'التحويل ما بين',
		options2l: 'الحسابات',
		options3f: 'السحب السريع',
		options3l: '',
	},

	forgotBox: {
		title: 'أعد تعيين كلمة المرور',
		email: 'البريد الإلكتروني',
		text1: 'برجاء إدخال بريدك الإلكتروني المسجل لدينا أدناه، وسنرسل ',
		text2: 'لك تعليمات لإعادة تعيين كلمة المرور الخاصة بك.',
		placeholderEmail: 'ادخل بريدك الإلكتروني',
		badFormatEmail:
			'برجاء التأكد من أن البريد الإلكتروني الذي أدخلته كامل وبصيغة صحيحة. مثال: username@mail.com',
		badEmail: 'من فضلك، ادخل بريدك الإلكتروني المسجل معنا',
		wrongEmail:
			'البريد الإلكتروني الذي أدخلته غير مسجل معنا. برجاء إدخال بريد إلكتروني صحيح والمحاولة مرة أخرى',
		continue: 'استمرار',
		limitExceeded: 'تجاوز الحد',
		requiredField: 'هذه الخانة مطلوبة.',
		goBackLogIn: 'ليس لديك حساب؟ سجل الآن.',
	},

	verifiCode: {
		title: 'تحقق من عنوان بريدك الإلكتروني',
		text1: 'لقد تم إرسال رمز التفعيل إلى بريدك الإلكتروني المسجل.',
		text2:
			'لقد تم إرسال رمز التفعيل إلى بريدك الإلكتروني المسجل. يرجى التحقق من صندوق الوارد الخاص بك وإدخال الرمز أدناه.',
		label1: 'رمز التفعيل',
		label2: 'ادخل الكود المكون من 6 أرقام. مثال 123456',
		label3: 'الرمز الذي أدخلته غير صالح. برجاء المحاولة مرة أخرى.',
		submit: 'إرسال',
		text3: 'لم تتلق أي رمز؟',
		text4: ' إعادة إرسال الرمز',
		alert1: 'تم إرسال رمز لمرة واحدة فقط إلى ',
		alert2: 'لا يمكننا إعادة إرسال الرمز الخاص بك الآن. حاول مرة أخرى.',
		alert3: 'رمز التحقق غير صحيح، يرجى المحاولة مرة أخرى.',
		error: 'حدث خطأ ما. يرجى التواصل مع ممثلينا على {contactInfo}',
	},

	setPassword: {
		title: 'تعين كلمة المرور الجديدة',
		text1: 'يرجى إدخال كلمة المرور الجديدة الخاصة بك، مع التأكد من أن ',
		text2: 'تختلف عن كلمات المرور المستخدمة سابقًا.',
		label1: 'كلمة المرور الجديدة',
		label2:
			'يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف إنجليزية على الأقل تتضمن حرفًا صغيرًا، حرفًا كبيرًا، رقمًا، و رمزا واحدًا على الأقل.  مثال على الرمز  !@#$%^&*',
		label3: 'تأكيد كلمة المرور',
		placeholder1: 'ادخل كلمة المرور الجديدة الخاصة بك',
		placeholder2: 'تأكيد كلمة المرور الجديدة الخاصة بك',
		error1:
			'يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف إنجليزية على الأقل تتضمن حرفًا صغيرًا، حرفًا كبيرًا، رقمًا، و رمزا واحدًا على الأقل.  مثال على الرمز  !@#$%^&*',
		error2:
			'كلمات المرور التي قمت بإدخالها غير متطابقة. برجاء التحقق وإعادة المحاولة مرة أخرى.',
		description:
			'لقد تم إرسال رمز التفعيل إلى بريدك الإلكتروني المسجل لدينا. برجاء التحقق من صندوق البريد الوارد الخاص بك وإدخال الرمز أدناه. بعد التحقق من صحة الرمز، يرجى إدخال كلمة المرور الجديدة، مع التأكد من أنها تختلف عن كلمات المرور المستخدمة سابقًا.',
	},

	setPasswordSuccess: {
		title1: 'م إعادة تعيين كلمة المرور',
		title2: 'الخاصة بك بنجاح!',
		login: 'تسجيل الدخول',
	},

	consoleHeader: {
		account: 'الحساب #',
		balance: 'الرصيد',
		equity: 'إكويتي',
		free: 'الهامش الحر',
		margin: 'مستوى الهامش',
		status: 'Status',
		hello: 'مرحبًا',
		logout: 'تسجيل الخروج',
		confirm: 'تأكيد',
		outModal: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
		yes: 'نعم',
		not: 'لا',
		settings: 'الإعدادت',
		areYouDone: 'تريد المغادرة؟ ',
		areYouSure: 'متأكد أنك تريد تسجيل الخروج؟ ستفقد أي تغييرات غير محفوظة. ',
		yesLogOut: 'نعم، سجل الخروج',
	},

	// Platforms page
	platforms: {
		description:
			'اجعل رحلة التداول الخاصة بك مخصصة قدر الإمكان عن طريق تنزيل أو استخدام إصدار الويب من المنصات التي تناسب نهجك وأهدافك في التداول. ',
		mainTitle: 'مركز التحميل',
		metatrader4: {
			desc1: 'واجهة مستخدم مخصصة وسريعة',
			desc2: 'سرعة تنفيذ لزيادة فعالية التداول',
			desc3: 'تقديم الطلبات بسلاسة',
			desc4: 'الإدارة الفعالة للمراكز',
			desc5: 'تصور حركة الأسعار لاتخاذ قرارات صائبة',
		},
		metatrader5: {
			desc1: 'أدوات التداول الأساسية التي تحتاجها',
			desc2: 'تنبيهات حتى لا تفوت الأحداث المهمة في الأسواق',
			desc3: 'دعم التداول الآلي',
			desc4: 'أدوات التحليل الفني وأكثر من 80 مؤشر تقني مدمج',
			desc5: 'أدوات متقدمة لتعزيز استراتيجيات التداول الخاصة بك',
		},
		cTrader: {
			desc1: 'تجربة تداول سريعة وسهلة الاستخدام',
			desc2: 'وصول مباشر إلى أسواق العملات',
			desc3: 'وضع الأوامر بسهولة',
			desc4: 'تقديم رؤى عميقة للسوق لاتخاذ قرارات حكيمة',
			desc5: 'تكنولوجيا متطورة لتعزيز التداول',
		},
		sterling: {
			desc1: 'مخططات بيانية قابلة للتخصيص، واختصارات للوصول السريع',
			desc2: 'معلومات السوق في الوقت الفعلي من المستوى الأول والثاني',
			desc3: 'مراقبة أرباح وخسائر المراكز في الوقت الفعلي',
			desc4:
				'أكثر من 60 نقطة بيانات لكل رمز تداول ضمن قائمة مراقبة شريطية قابلة للتخصيص',
			desc5: 'أكثر من 90 حزمة من المؤشرات التقنية والدراسات',
		},
		lightspeed: {
			desc1: 'مصادر متعددة لتحديد المواقع وبأسعار متنوعة',
			desc2: 'إمكانية تخصيص الأوامر بناء على الإعدادات التي قمت بضبطها سابقًا',
			desc3: 'نماذج أوامر الخيارات للاستراتيجيات المعقدة',
			desc4: 'قوائم مراقبة قابلة للتخصيص من أجل تسريع عملية تقديم الأوامر',
			desc5: 'إعدادات متكاملة لإدارة المخاطر',
		},

		takion: {
			desc1: 'أنواع رسوم بيانية متعددة، أطر زمنية مختلفة، ومؤشرات فنية كثيرة.',
			desc2: 'تداول مباشر مع الوصول إلى الأسواق لدعم كفاءة التداول.',
			desc3: 'وصول سريع إلى البيانات المتقدمة والأخبار',
			desc4: 'بيانات المستوى الثاني وبيانات الوقت والمبيعات في الوقت الحقيقي',
			desc5: 'مساحات عمل لعمليات تداول سلسة',
		},

		das: {
			desc1: 'أنواع أوامر متقدمة ومخططات في الوقت الفعلي',
			desc2: 'إدارة حسابات متعددة',
			desc3: 'اختصارات سريعة قابلة للتخصيص لوضع الأوامر بسرعة',
			desc4: 'تحقق من الأوامر في سوق الأسهم الأمريكية بزمن وصول منخفض',
			desc5: 'وصول إلى بيانات السوق في الوقت الفعلي',
		},

		api: {
			desc1: 'اتصال مباشر بخدمات التداول لدينا بشكل لحظي',
			desc2: 'تنفيذ سريع وتخصيص لمنصة التداول',
			desc3: 'سيطرة كاملة على البيانات المقدمة والمستلمة',
			desc4: 'خيارات مختلفة لأوامر السوق والحد',
			desc5: 'استراتيجية تداول مرنة',
		},
		cqg: {
			desc1: 'واجهات تداول سهلة الاستخدام',
			desc2: 'رسوم بيانية وتحليلات متقدمة',
			desc3:
				'بيانات في الوقت الفعلي مع مجموعة متنوعة من أنماط الأسعار بما في ذلك الخرائط الحرارية',
			desc4: 'إدارة الأوامر والمراكز',
			desc5: 'أخبار RSS',
		},
		thanksForYourInterest: 'شكرا لاهتمامك بفتح حساب مع تريد فيو!',
		weWillContactYou:
			'سيتواصل معك ممثل من Tradeview قريبًا لمساعدتك في إعداد حسابك التجريبي الجديد.',
		createAccountToDownload: 'أنشئ حسابًا لتحميل هذه المنصة.',
		createAccount: 'إنشاء حساب',
		platformNotCovered:
			'هذه المنصة غير مشمولة بحسابك الحالي. لتحميلها واستخدامها، يرجى إنشاء حساب مخصص لهذا السوق والمنصة.',
		btn_downd: 'تنزيل',
		btn_launch: 'استخدام نسخة الويب',
		btn_request: 'تحميل عند الطلب',
		okay: 'حسنًا',
		continue: 'استمرار',
		requestAccount: 'طلب فتح حساب',
		disabledOptionAlert:
			'لا نستطيع بدء تنزيل المنصة الآن. برجاء الانتظار لمدة 10 ثوان بين كل محاولة تنزيل والأخرى.',
		modal_reminder: {
			title: 'تذكر',
			descript1: 'جاري تحميل المنصة! حتى تتمكن من الدخول إلى ',
			descript2:
				'استخدم بيانات تسجيل الدخول التي أرسلناها إليك عبر البريد الإلكتروني. إن لم يكن لديك حساب لهذه المنصة حتى الآن، يمكنك تقديم الطلب الآن أو في أي وقت. تذكر أنه لا يمكنك الدخول إلى هذه المنصة إلا عبر حساب التداول.',
			descript3: '',
			descript3sub: '',
			descript1sub: 'للوصول إلى،',
			descript2sub:
				'استخدم بيانات تسجيل الدخول التي أرسلناها إليك عبر البريد الإلكتروني. إن لم يكن لديك حساب لهذه المنصة حتى الآن، يمكنك تقديم الطلب الآن أو في أي وقت. تذكر أنه لا يمكنك الدخول إلى هذه المنصة إلا عبر حساب التداول.',
			descript3sub: '',
		},

		modal_send: {
			title: 'تم ارسال طلبك',
			descript:
				'شكرًا لاهتمامك! سنتواصل معك قريبًا لمساعدتك في إعداد المنصة التي اخترتها',
		},
		acessPlatforms:
			'أنت بحاجة إلى حساب تداول للوصول إلى هذه المنصات. يمكنك فتح حساب من ',
		acessPlatformsContinue: '',
		webVersionModal: 'تشغيل النسخة الإلكترونية',
		toAccess:
			'للوصول إلى MT5، استخدم بيانات الاعتماد التي أرسلناها إليك عبر البريد الإلكتروني. إذا لم تطلب حسابًا لهذه المنصة بعد، يمكنك القيام بذلك الآن أو في أي وقت. تذكّر، الوصول يتطلب وجود حساب.',
		selectTypeAccount:
			'اختر نوع الحساب الذي تريد استخدامه لتشغيل النسخة الإلكترونية:',
		live: 'حقيقي',
		demo: 'تجريبي',
		launch: 'تشغيل',
	},

	//History page
	history: {
		titleH: 'سجل تداولاتك',
		periodTimeL: 'الفترة الزمنية',
		periodTimeP: 'كل السجل',
		typeL: 'النوع',
		typeP: 'اختر النوع',
		platformL: 'المنصة',
		platformP: 'اختر منصة',
		accountL: 'حساب التداول',
		accountP: 'رقم الحساب',
		fromL: 'من',
		fromP: 'mm/dd/yyyy',
		toL: 'إلى',
		toP: 'mm/dd/yyyy',
		clearBtn: 'مسح',
		exportBtn: 'استخراج التقرير',
		getBtn: 'سلم طلبك',
		optionsAccounts: 'اختر حسابك للتداول',
		infoAlertD: 'اختر حساب لاستعراض تحديثاته هنا.',
		noHistoryYet1: 'الفلاتر المحددة للحساب',
		noHistoryYet2: 'لا تحتوي على أي تاريخ بعد',
		platformAlertD:
			'برجاء الانتباه: يمكن عرض حسابات منصات MT4، MT5فقط ضمن خيارات التصفية والجدول بالأسفل. أما الحسابات الموجودة على المنصات الأخرى، فيمكنك الوصول إلى سجل التداول عليها من خلال المنصات نفسها. ',
		accountTypeH: 'نوع الحساب',
		accountTypeP: 'اختر نوعًا',
		alertExport: 'تم تسجيل معلوماتك بنجاح',
		btnFilter: 'المرشحات',
		alertPlatforMobile:
			'يرجى الملاحظة : يظهر بالأسفل حسابات MT4، MT5 فقط. يمكنك الوصول إلى سجل التداول لمنصات التداول الأخرى من المنصات نفسها.',
		modalHeader: 'متأكد أنك تريد المغادرة؟',
		modalDescription:
			'في حالة مغادرتك الآن، فسوف تضطر لإعادة إدخال المعلومات مرة اخرى لاتمام طلبك.',
		btnModalCancel: 'إلغاء',
		btnModalYes: 'نعم، متأكد',
		filterbyactivity: 'التصفية حسب نوع النشاط',
		accountTooltip:
			'رقم الحساب المرتبط بالحركة. في حالةالتحويلات، يرمز<br>الأيقونة  ',
		accountTooltip2: '   إلى التحويلات التي دخلت حسابك المستعلم عنه، و',
		accountTooltip3: 'إلى التحويلات التي خرجت من حسابك.',
		accountTooltipIn: 'رقم الحساب المكتوب هو الحساب الذي تم تحويل المبلغ منه',
		accountTooltipOut:
			'تحويل خرج من حسابك المستعلم وتم إرساله إلى الحساب الوجهة المدرج في هذا العمود.',
		selectActivity: 'حدد النشاط',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: 'الحساب المراد التحويل منه',
		currency: 'نوع العملة',
		currencyType: 'نوع العملة',
		details: 'معلومات البنك المستفيد',
		beneficiaryDetails: 'معلومات البنك المستفيد',
		swiftt: 'رقم السويفت',
		branch: 'اسم الفرع',
		branchCode: 'اسم الفرع',
		enterbranch: 'أدخل رمز الفرع الخاص بك',
		province: 'الولاية',
		city: 'المدينة',
		bank: 'بنك DBS',
		bankK: 'بنك',
		bankTransfer: 'اختر بنكًا للتحويل الخاص بك',
		withdrawFunds: 'تقديم طلب سحب',
		withdrawalMethod: 'طريقة السحب',
		withdrawalAmmount: 'مبلغ السحب',
		keepInMind: 'تنبيه:',
		withdrawalCalendar: '',
		withdrawalMustMatchDeposit:
			'يجب أن تكون طريقة السحب المختارة، هي نفس طريقة الإيداع. يجب ألا تتجاوز مبالغ السحب التي تمت من خلال المحافظ الرقمية وبطاقة الائتمان، مبالغ الإيداع الأصلية.',
		beneficiaryName: 'اسم البنك',
		beneficiaryAccount: 'حساب المستفيد',
		bankAddress: 'عنوان البنك',
		enterBankAddress: 'أدخل عنوان البنك الخاص بك',
		enterBeneficiaryName: 'ادخل اسم البنك',
		beneficiaryAddress: 'عنوان المستفيد',
		enterBeneficiaryAddress: 'ادخل عنوان المستفيد',
		enterYourAddress: 'ادخل عنوان المستفيد',
		accountNumber: 'رقم الحساب',
		iban: '(IBAN)',
		aliasiban: '(إذا كانت الحساب خارج المملكة المتحدة - اختياري)',
		enterAccountNumber: 'ادخل رقم حسابك البنكي',
		bankName: 'اسم البنك',
		enterBankName: 'ادخل اسم البنك',
		swiftCode: 'رقم السويفت',
		enterSwiftCode: 'ادخل رقم السويفت الخاص بالبنك',
		enteryourSwiftCode: 'ادخل رقم السويفت الخاص بالبنك',
		aliasSwiftCode: ' (إذا كانت الحساب خارج المملكة المتحدة - اختياري)',
		abaNumber: 'رقم ABA',
		enterAbaNumber: 'ادخل رقم ABA للبنك',
		aliasAbaNumber: '(للاستخدام المحلي في الولايات المتحدة - اختياري)',
		sortCodeClabe: 'رمز الفرز/ CLABE',
		enterSortCodeClabe: 'ادخل رمز الفرز/ CLABE',
		referenceNumber: 'الرقم المرجعي',
		enterReferenceNumber: 'ادخل الرقم المرجعي',
		associatedEmail: 'عنوان البريد الإلكتروني المسجل',
		associatedEmailLabel: 'عنوان البريد الإلكتروني المسجل',
		enterAssociatedEmailAccount: 'ادخل عنوان البريد الإلكتروني المسجل',
		doYouNeedIntermediary: 'هل أنت بحاجة إلى بنك وسيط؟',
		selectAnOption: 'يرجى اختيار أحد الخيارات',
		pleaseSelectAnOption: 'يرجى اختيار أحد الخيارات',
		enterCashAmount: 'ادخل المبلغ المراد سحبه',
		helperCashTransfer:
			'المبلغ الذي أدخلته أكثر من 25,000 دولار أمريكي. سيقوم فريقنا بمراجعة التحويل للموافقة عليه خلال 24 ساعة من اليوم العملي التالي.',
		intermediaryBank: 'بيانات البنك الوسيط',
		intermediaryBankk: 'البنك الوسيط',
		ifNeeded: '(إذا لزم الأمر)',
		intermediaryBankName: 'اسم البنك الوسيط',
		banescoAccountName: 'اسم صاحب الحساب',
		enterAccountName: 'أدخل اسم حسابك',
		clabe: 'CLABE',
		clabealias: '(رقم الحساب)',
		enterclabe: 'أدخل CLABE الخاص بك',
		pesosAccount: 'رقم حساب البيزو',
		clabe: 'كلافة (CLABE)',
		enterIntermediaryBankName: 'ادخل اسم البنك الوسيط ',
		intermediaryBankAddress: 'عنوان البنك الوسيط',
		enterintermediaryBankAddress: 'ادخل عنوان البنك الوسيط ',
		ibanNumber: 'رقم الآيبان',
		enterIbanNumber: 'ادخل رقم الآيبان',
		withdrawalCompleted: 'تم سحب أموالك بنجاح!',
		withdrawalIsComplet: 'تم أستقبال طلب السحب',
		withdrawalIsCompletDescription:
			'تم استقبال طلب السحب الخاص بك وجاري العمل على إتمامه.',
		withdrawalCompletedDescription:
			'ستكون أموالك متاحة في حساب الوجهة الخاص بك قريبًا. يعتمد وقت المعالجة على طري	قة السحب التي اخترتها.',
		withdrawNotCompleted: 'لم تكتمل عملية السحب الخاصة بك',
		withdrawNotCompletedDescription:
			'لم تتم عملية السحب بنجاح. برجاء مراجعة تفاصيل معلومات السحب وإعاده المحاولة مرة أخرى. في حالة عدم تمكنك من إتمام السحب يرجى التواصل معنا.',
		contactUs: 'اتصل بنا',
		goToMyAccount: 'اذهب إلى حسابي',
		creditCardDetails: 'معلومات بطاقة الائتمان',
		important: 'يرجى الملاحظة:',
		withdrawalsExceeding:
			'لا يمكن أن يتجاوز مبلغ السحب المبلغ الأصلي الذي قمت بإيداعه من خلال بطاقة الائتمان. يمكنك فقط سحب نفس مبلغ الإيداع أو أقل منه. لسحب الأرباح، يمكنك استخدام طريقة سحب بديلة.',
		creditCardLastDigits: 'أخر 4 أرقام من بطاقة الائتمان',
		enterCreditCardLastDigits: 'ادخل أخر 4 أرقام من بطاقة الائتمان',
		netellerAccountDetails: 'معلومات حساب Neteller',
		netellerComission:
			'نود أن ننوه أنه قد يكون هناك مصاريف تحويل اضافية اذا استخدمت سكريل للسحب.',
		netellerComissionMena:
			'We would like to inform you that due to increasing costs associated with Neteller, we will charge a fee of 1% on all deposits and withdrawals made via Neteller. Fees can be waived in certain circumstances after a review of your account with your Tradeview representative.',
		skrillAccountDetails: 'معلومات حساب Skrill',
		upholdAccountDetails: 'معلومات حساب Uphold',
		bitwalletAccountDetails: 'معلومات حساب Bitwallet',
		interacAccountDetails: 'تفاصيل حسابك Interac e-Transfer',
		interacHelpMsg: '*علامة تجارية لشركة Interac Corp. تستخدم بموجب ترخيص.',
		upholdComission:
			'في حالة الإرسال إلى حساب Uphold فلا يتم فرض أي رسوم. أما في حالة الإرسال إلى محافظ عملات رقمية أخرى فإن تريد فيو لا تفرض رسومًا، ولكن تفرض Uphold الرسوم التالية: رسوم الصرف (1.05%)، رسوم الشبكة (0.0003 BTC)، رسوم السحب (0.0004 BTC).',
		bitPayTitle: 'معلومات BitPay',
		destinationAccount: 'الحساب المراد التحويل اليه',
		bitPayCommision:
			'يتم فرض الرسوم التالية: رسوم الصرف (1.05%)، رسوم الشبكة (0.0003 BTC)، رسوم السحب (0.0003 BTC)',
		needYourAuth: 'بحاجة إلى التأكيد:',
		confirmThoughtEmail:
			'بعد تقديم طلب السحب هذا، سنكون بحاجة إلى تأكيد عبر البريد الإلكتروني المسجل في حسابك.',
		wallet: 'المحفظة',
		enterYourWallet: 'أدخل محفظتك',
		enteryourEmailAccount: 'ادخل البريد الإلكتروني',
		sticPayAccountDetails: 'معلومات حساب SticPay',
		voletAccountDetails: 'معلومات حساب Volet',
		interacAccountDetails: 'معلومات حساب Interac e-Transfer ',
		fasapayAccountDetails: 'معلومات حساب Fasapay',
		searchABank: 'ابحث عن بنك',
		searchAnAccount: 'ابحث عن حساب',
		ibanIfApplicable: '(رقم الحساب البنكي الدولي IBAN إذا كان ذلك ينطبق)',
		beneficiaryBankName: 'اسم البنك المستفيد',
		enterBeneficiaryBankName: 'اسم البنك المستفيد',
		enterYourProvince: 'أدخل محافظتك',
		enterYourCity: 'أدخل مدينتك',
		unionPayDetails: 'معلومات UnionPay',
		jpayDetails: 'معلومات حساب JPay ',
		jpayAccountDetails: 'معلومات حساب JPay ',
		walletAndCrypto: 'المحافظ والعملات الرقمية',
		walletAndCryptoAlert:
			'عند إجراء سحب باستخدام العملات الرقمية، فإن هناك رسوم تحويل تبلغ 0.7%.',
		crypto: 'العملات الرقمية',
		selectCrypto: 'اختر نوع العملة مشفرة',
		tag: 'Tag',
		enter: 'Enter',
		cryptocurrency: 'العملات الرقمية',
		enterCryptocurrency: 'أدخل العملة المشفرة',
		otherCurrency: 'عملات رقمية أخرى',
		enterOtherCurrency: 'أدخل عملة مشفرة أخرى',
		areYouSure: 'متأكد أنك تريد المغادرة؟ ',
		ifYouLeaveNow:
			'في حالة مغادرتك الآن، فسوف تضطر لإعادة إدخال المعلومات مرة اخرى لاتمام طلبك.',
		noStay: 'لا، أريد البقاء',
		yesLeave: 'نعم، أريد المغادرة',
		requestSubmited: 'تم تقديم طلبك بنجاج!',
		reviewEmail: 'رجاء التحقق من البريد الإلكتروني المسجل.',
		unsuccessfulWithdraw: 'لم تتم عملية السحب بنجاح',
		reviewAgain:
			'يرجى مراجعة معلومات السحب الخاصة بك والمحاولة مرة أخرى. إذا استمرت المشكلة،',
		amountTryAgain: 'المبلغ يتعدى الحد المسموح بسحبه. يرجى المحاولة مرة أخرى.',
		amountTryAgainWithdraw:
			'يتجاوز المبلغ المراد سحبه المبلغ الموجود في الحساب. برجاء إعادة المحاولة.',
		minimunAmount:
			'الحد الأدنى للسحب من خلال التحويلات البنكية هو 50 دولار أمريكي',
		minimunAmount100: 'الحد الأدنى للسحب لهذه الطريقة هو 100 دولار أمريكي.',
		minimunAmount0: 'الحد الأدنى للسحب لهذه الطريقة هو 0,00001 بيتكوين (BTC).',
		invalidEmail: 'تنسيق البريد الإلكتروني غير صالح',
		invalidAccountNumber: 'تنسيق رقم الحساب غير صالح',
		noAvailableOptions: 'لا توجد خيارات متاحة',
		closeModal:
			'يرجى الانتباه أنه في حالة مغادرتك الآن، فلن يتم حفظ أي معلومات قمت بتقديمها. إن كنت تريد السحب في وقت لاحق، فستبدأ من جديد  بملء كافة البيانات المطلوبة.',
		successWithdraw:
			'تمت عملية السحب بنجاح. ستصل أموالك إليك قريبًا جدًا. يختلف وقت معالجة عملية السحب حسب طريقة السحب التي اخترتها.',
		fundCreditCard: 'أودع الان!',
		selectMethod:
			'يمكن أن يتم السحب من خلال عدة خيارات متاحة وتشمل: حساب بنكي، بطاقة بنكية، بنك إلكتروني، محفظة عملات رقمية.',
		invalidCreditCardDigits: 'أرقام البطاقة غير صالحة',
		phone: 'الهاتف',
		enterYourPhone: 'أدخل رقم هاتفك',
		invalidPhone: 'تنسيق الهاتف غير صالح',
		modalPreferences: 'لا داعي لإعادة السؤال مرة اخرى',
		bankFee: '$35 USD',
		bankBranch: 'فرع البنك',
		enterBankBranch: 'أدخل فرع البنك الخاص بك',
		branchProvince: 'محافظة الفرع',
		enterBranchProvince: 'أدخل محافظة الفرع الخاص بك',
		branchCity: 'مدينة الفرع',
		enterBranchCity: 'أدخل مدينة الفرع الخاص بك',
		bankTransfer: 'تحويل بنكي',
		bankTransferOption: 'اختر بنكًا للتحويل الخاص بك',
		creditCard: 'بطاقات بنكية',
		cryptoWallet: 'عملات رقمية',
	},

	//Account Activity page
	accountActivity: {
		title: 'نشاط الحساب',
		from: 'من',
		to: 'ل',
		type: 'النوع',
		platform: 'أداة التداول',
		placeholderAccount: 'حساب التداول',
		account: 'حساب التداول',
		get: 'الحصول على المعلومات',
		row: 'الصفوف للصفحة',
		download: 'تنزيل التقرير',
		back: 'العودة إلى الخلف',
		confirm: 'تأكيد',
		close: 'يغلق',
		error: 'خطأ! لا يمكن أن تكون هناك حقول فارغة',
		errorTwo: 'خطأ! يجب عليك تحديد نوع الحقل.',
		activityid: 'معرف النشاط',
		platfomr: 'المنصة',
		date: 'التاريخ / الوقت',
		activity: 'النشاط',
		profit: 'الربح أو الخسارة',
		timeSegmentation: 'تقسيم الوقت',
		timeFrame: 'اختر إطار زمني',
		selectType: 'اختر النوع',
		selectMarket: 'اختر سوق',
		tradingAccount: 'اختر حسابك للتداول',
		segmentation: 'تقسيم الوقت',
		segmentationPlaceholder: 'اختر إطارًا زمنيًا',
		platformPlaceholder: 'اختر منصة',
		alert: 'تم تسجيل معلوماتك بنجاح',
		infoYet:
			'لم تسفر عوامل التصفية التي اخترتها عن أية نتائج. برجاء المحاولة مرة أخرى.',
	},

	//tradingHistory
	tradingHistory: {
		title: 'تاريخ التداول',
		from: 'من',
		to: 'ل',
		type: 'النوع',
		platform: 'المنصة',
		placeholderAccount: 'حساب التداول',
		account: 'الحساب',
		get: 'الحصول على المعلومات',
		row: 'الصفوف للصفحة',
		download: 'تنزيل التقرير',
		back: 'العودة إلى الخلف',
		confirm: 'تأكيد',
		close: 'يغلق',
		error: 'خطأ! لا يمكن أن تكون هناك حقول فارغة',
		errorTwo: 'خطأ! يجب عليك تحديد نوع الحقل.',
		deal: 'الصفقة',
		entryTime: 'وقت الدخول',
		typr: 'النوع',
		simbol: 'الرمز',
		volume: 'حجم التداول',
		entryPrice: 'سعر الدخول',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: 'وقت الخروج',
		exitPrice: 'سعر الخروج',
		commision: 'عمولة',
		bankFee: 'اللجنة',
		swap: 'السواب',
		profit: 'الربح أو الخسارة',
		dateFrom: 'yyyy/mm/dd',
		dateTo: 'yyyy/mm/dd',
		openingTime: 'وقت الفتح',
		openingPrice: 'سعر الفتح',
		stopLoss: 'وقف الخسارة',
		takeProfit: 'جني الأرباح',
		closingTime: 'وقت الإغلاق',
		closingPrice: 'سعر الاغلاق',
		comission: 'العمولة',
		time: 'الوقت',
	},

	//Transfer page
	transfer: {
		mainTitle: 'تحويل الأموال بين حسابات التداول',
		isBackValidation:
			'يجب على فريقنا مراجعة التحويل الخاص بك للموافقة عليه. قد يستغرق ذلك ما يصل إلى 24 ساعة من يوم العمل التالي.',
		pleaseNote:
			'يرجى الانتباه أن التحويلات متاحة فقط بين الحسابات المملوكة لنفس الشخص.',
		mena: {
			consentCheck:
				'من خلال تحديد المربع، أقر بأنني طلبت تحويل الأموال من أحد حساباتي على تريدفيو إلى حساب آخر من حساباتي على تريدفيو.',
		},
		ltd: {
			consentCheck:
				'من خلال تحديد المربع، أقر بأنني طلبت تحويل الأموال من أحد حساباتي على تريدفيو إلى حساب آخر من حساباتي على تريدفيو.',
		},
		latam: {
			consentCheck:
				'من خلال تحديد المربع، أقر بأنني طلبت تحويل الأموال من أحد حساباتي على تريدفيو إلى حساب آخر من حساباتي على تريدفيو.',
		},
		markConsentCheck: 'يجب الضغط على مربع الإقرار للاستمرار.',
		transferAmount: 'الحساب الذي سيتم تحويل الأموال منه.',
		transferCompleted: 'تمت عملية التحويل بنجاح',
		transferReview: 'عملية التحويل قيد المراجعة',
		transferInCompleted: 'لم تتم عملية التحويل بنجاح',
		transferInCompletedDescription:
			"لم تتم عملية التحويل بنجاح، رجاء التأكد من صحه رقم الحساب المحول منه واليه ثم معاودة المحاولة مره أخرى، في حاله عدم قدرتك علي إتمام التحويل رجاء <a href='https://cabinet.tvmarkets.com/ar/cabinet/console/contact_us'>التواصل معنا.</a>",
		transferDescription: 'جاري تحويل الاموال.',
		transferDescriptionReview:
			'التحويل الخاص بك قيد المراجعة الآن. سيتواصل معك فريقنا عبر البريد الإلكتروني عند اتمام الطلب.',
		destinationAccount: 'الحساب الذي ستحول إليه الأموال',
		minimunAmount: 'الحد الأدنى الذي يمكنك تحويله بهذه الطريقة هو 10 دولار.',
	},

	//Accounts
	accounts: {
		refresh: 'تحديث',
		liveAccounts: 'حسابات حقيقية',
		demoAccounts: 'حسابات تجريبية',
		createLive: '+ فتح حساب تداول حقيقي',
		createDemo: '+ فتح حساب تجريبي',

		createAccount: 'فتح حساب إضافي',
		createDemoAccount: 'فتح حساب تجريبي',
		createLiveAccount: 'فتح حساب تداول حقيقي',
		livee: 'حقيقي',
		demoo: 'تجريبي',
		yourBalance: 'رصيد حسابك',
		cardPlatform: 'المنصة',
		equityy: 'إكويتي',
		marginLevel: 'مستوى الهامش',
		freeMargin: 'الهامش الحر',
		statuss: 'الحالة',
		leveragee: 'الرافعة المالية',
		credit: 'الائتمان',
		phone: 'الهاتف',
		selectLeverage: 'اختر رافعة مالية',
		noLiveAccount:
			'ليس لديك حساب حقيقي. اختر حسابًا يناسب احتياجاتك وابدأ التداول الآن.',
		noDemoAccount:
			'ليس لديك حساب تجريبي. اختر واحدًا يناسب احتياجاتك وابدأ التدريب.',
		tradingInstrument: 'سوق التداول',
		tradingMethodTooltip:
			"تعني أسواق التداول، أي سوق يمكنك التداول من خلاله. تشمل هذه الأسواق العقود الآجلة للسلع، الأسهم، عقود الفروقات، الفوركس، المعادن وغيرها.<br><br> لست متأكد أي سوق تريد التداول فيها؟ <br> استعرض الأسواق من  <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>هنا.</a>",
		here: 'هنا',
		selectAMarket: 'اختر سوق',
		platform: 'المنصة',
		selectAPlatform: 'اختر منصة',
		cashAmount: 'مبلغ الإيداع',
		selectCashAmount: 'اختر مبلغ الإيداع',
		accountType: 'نوع الحساب',
		selectAnAccount: 'اختر نوع الحساب',
		currencyy: 'نوع العملة',
		selectACurrency: 'يرجى اختيار أحد الخيارات',
		platformTooltip:
			"منصة التداول، هي برنامج تقني تستخدمه لتنفيذ عمليات التداول من فتح وإغلاق المراكز في حسابك. <br><br>يمكنك التعرف على التفاصيل الخاصة بكل نوع حساب من <a href='https://www.tvmarkets.com/trading/platforms' target='_blank'>هنا.</a>",
		accountTypeTooltip:
			'نوع الحساب يسمح لك باختيار شروط التداول (الرافعة المالية، الفروق، العمولات) لحسابك.',
		accountTypeTooltip2: 'يمكنك مراجعة الشروط لكل نوع حساب.',
		applicationCompleted: 'تم تقديم طلبك بنجاح!',
		applicationCompletedDescription:
			'يتم حاليًا مراجعة طلبك لفتح حساب إضافي حقيقي، و سوف نقوم بالتواصل معك عبر الايميل . سيقوم أحد افراد الدعم بالتواصل معك إن كنا بحاجة إلى وثائق إضافية.',
		applicationError: 'لم يتم تقديم طلبك',
		applicationErrorDescription:
			'لقد حدث خطأ أثناء إرسال الطلب. فريقنا التقني على علم بهذه المشكلة.',
		applicationErrorDescription2:
			'برجاء إعادة المحاولة. في حالة استمرار المشكلة،',
		sureToLeave: 'متأكد أنك تريد المغادرة؟ ',
		processUncompleted:
			'في حالة مغادرتك الآن، فسوف تضطر لإعادة إدخال المعلومات مرة اخرى لاتمام طلبك.',
		cardPlatform: 'المنصة',
		setDemoAccount:
			'نحن نقوم بإعداد حسابك التجريبي الجديد. بمجرد أن يكون جاهزًا، ستجد جميع التفاصيل هنا.',
		cancel: 'إلغاء',
		active: 'نشط',
		accountSettings: 'إعدادات الحساب',
		changePw: 'تغيير كلمة مرور هذا الحساب',
		changeLv: 'تغيير الرافعة المالية لهذا الحساب',
		setLv: 'تعيين الرافعة المالية الجديدة لحسابك',
		underReview: 'تحديثك قيد المراجعة',
		underReviewDesc:
			'رافعتك المالية الجديدة قيد المراجعة وسيتم التحقق منها قريبًا. سيتواصل معك فريقنا عبر البريد الإلكتروني بمجرد اكتمال العملية.',
		successLev: 'تم تحديث الرافعة المالية بنجاح!',
		changePsw: 'تغيير كلمة المرور الخاصة بك',
		forgotPw: 'هل نسيت كلمة المرور؟ من فضلك، {contact}.',
		updatePw: 'تم تحديث كلمة المرور الخاصة بك بنجاح!',
		statusTooltip:
			'قد يكون حسابك غير نشط لأسباب عديدة، مثل نقص المعلومات أو الوثائق المطلوبة. تحقق من لوحة التحكم الخاصة بك لأي تنبيهات. إذا كنت غير متأكد من السبب، من فضلك {contact}.',
		failedReq: 'نأسف! حدث خطأ',
		failedReqDesc:
			'يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، {contact} للحصول على المساعدة.',
		forex: 'العملات و السلع و المعادن',
		mt4: 'MT4 - منصة ميتاتريدر 4',
		mt5: 'MT5 - منصة ميتاتريدر 5',
		iLC: 'اسبرد اي سي ان - ILC',
		XLeverage: 'اسبرد كلاسيكي - XLeverage',
	},

	tooltips: {
		currencyType: 'العملة هي طريقة الدفع التي ستتعامل بها في حسابك.',
		leverageTM:
			'تمكنك الرافعة المالية من فتح مراكز أكبر برأس مال أقل، حيث تعمل على تضخيم رأسمالك. يتم التعبير عنها بنسب مثل 1:50 أو 1:100، مما يعني نسبة الرفع التي تستخدمها عند التداول.',
	},

	applicationForm: {
		submitContact: 'تواصل معنا.',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: 'تسجيل الدخول',
		pass: 'كلمة المرور',
		currencyTwo: 'نوع العملة',
		server: 'الخادم',
		ilc: 'iLC',
		xleverage: 'xLeverage',
		dontForget:
			'لا تنس حفظ بيانات الدخول إلى حسابك قبل إغلاق هذه النافذة. سيتم إرسال هذه المعلومات إلى بريدك الإلكتروني المسجل لدينا',
		downloadCred: 'حفظ بيانات الدخول',
		choosePlatform:
			'مبروك! أنت الآن جاهز لاختيار وتنزيل منصة التداول الخاصة بك',
		ifYouChooseMT4:
			'يرجى العلم أن عملية تثيبت منصة التداول ستكون مختلفة إن قمت باختيار MT4 على نظام تشغيل Mac OS. يمكنك الحصول على إرشادات التثبيت من هنا.',
		ifYouChooseMT4Continuation: '',
		thanksForRegistering: 'شكرًا على التسجيل!',
		otherStock:
			'سيتواصل معك ممثل من Tradeview قريبًا لمساعدتك في إعداد حسابك التجريبي الجديد.',
		stockMT52: 'بينما يتم إعداد حسابك، لا تتردد في ',
		stockMT53: 'استكشاف موقعنا الإلكتروني',
		stockMT54: 'واكتشاف المزيد عن Tradeview.',
		accountTypeDemo:
			"يتيح لك نوع الحساب تحديد شروط التداول مثل الرافعة المالية، فروق الأسعار والعمولات في حسابك. <br><br>يمكنك التعرف على التفاصيل الخاصة بكل نوع حساب من  <a href='https://www.tvmarkets.com/trading/accounts' target='_blank'>  هنا.</a>",
		applicationCompleted: 'تم إنشاء حسابك التجريبي بنجاح!',
		pdfCredentialTitle: 'عزيزي المتداول',
		pdfCredentialDescription1: 'شكرًا لاختيارك لنا لبدء رحلتك في التداول.',
		pdfCredentialDescription2: 'نحن متحمسون لانضمامك إلينا.',
		pdfCredentialDescription3: 'إليك بيانات اعتماد حسابك:',
		pdfCredentialEmail: 'البريد الإلكتروني:',
		pdfCredentialPassword: 'كلمة المرور:',
		pdfCredentialCurrency: 'العملة:',
		pdfCredentialServer: 'الخادم:',
		pdfCredentialInstructions: 'التعليمات:',
		pdfCredentialInstructions2:
			'استخدم البريد الإلكتروني وكلمة المرور المسجلة لديك',
		pdfCredentialTo: 'لـ',
		pdfCredentiallogin: 'تسجيل الدخول',
		pdfCredentialTVAccount: 'إلى حساب Tradeview الخاص بك.',
		pdfCredentialChangeP: 'يمكنك تغيير كلمة المرور أو إعداد التحقق الثنائي',
		pdfCredentialSettings: 'في قسم "الإعدادات" في اللوحة.',
		pdfCredentialFamiliarize: 'تعرف على منصتنا، استكشف الميزات،',
		pdfCredentialExperience: 'وابدأ بتجربة الفرق مع Tradeview.',
		pdfCredentialSupport: 'نحن هنا لدعمك في كل خطوة. إذا كان لديك أي أسئلة',
		pdfCredentialNeed:
			'أو كنت بحاجة إلى مساعدة، لا تتردد في التواصل مع فريق الدعم المخصص لدينا.',
		pdfCredentialTeam: 'فريق الدعم.',
		pdfCredentialHappy: 'تداول سعيد!',
		pdfCredentialRegards: 'أطيب التحيات،',
		pdfCredentialTVTeam: 'فريق Tradeview',
	},

	//Create Live Accounts
	liveAccount: {
		login: 'تسجيل الدخول',
		pass: 'كلمة المرور',
		server: 'الخادم',
		platform: 'المنصة',
		status: 'الحالة',
		statusFalse: 'غير نشط',
		statusTrue: 'نشط',
		dontForget:
			'لا تنس حفظ بيانات الدخول إلى حسابك قبل إغلاق هذه النافذة. سيتم إرسال هذه المعلومات إلى بريدك الإلكتروني المسجل لدينا.',
		downloadCred: 'حفظ بيانات الدخول',
		applicationCompleted: 'تم فتح حساب تداول إضافي!',
	},

	//credit card
	credit: {
		edit: 'تعديل',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: 'المبلغ',
	},

	//fidelity
	fidelity: {
		routingNum: 'رقم التوجيه',
		swiftCodebic: 'رمز السويفت (Swift code/BIC)',
		disclaimer:
			'تعليمات الإيداع هذه مخصصة فقط للمقيمين في جزر كايمان. إن كنت مقيم في بلد أخر، برجاء استخدام بنك بديل.',
	},

	//Bbva
	bbva: {
		ruc: 'RUC',
		accountninfo: '0011-0351-0100035781',
		nameBenef: 'اسم البنك',
		interbank: 'رقم الانتربنك (CCI)',
	},

	//deposit
	deposit: {
		title: 'اختر طريقة الإيداع',
		depositMethod: 'طريقة الإيداع',
		processingCards: 'وقت المعالجة',
		fee: 'الرسو',
		crypto: 'عملات رقمية',
		digitalWallets: 'بنوك إلكترونية',
		cardTransfer: 'بطاقات بنكية',
		wireTransfer: 'تحويل بنكي',
		btnDepositFunds: 'إيداع الأموال',
		selectAnOption: 'اختر طريقة الايداع',
		depositUnderReview: 'الإيداع قيد المراجعة',
		depositUnderReviewDescription:
			'إيداعك الآن قيد المراجعة. سيتواصل معك فريقنا عبر البريد الإلكتروني بمجرد اكتمال عملية الإيداع.',
		depositUnderReviewErrorDescription:
			'واجهنا مشكلة أثناء معالجة الإيداع. يرجى التحقق من معلومات الدفع والمحاولة مرة أخرى. إذا استمرّت المشكلة، تواصل معنا.',
		depositCompleted: 'تمت عملية الإيداع بنجاح',
		depositCompletedDescription: 'ستصل المبلغ المودع في حسابك قريبًا.',
		despositInCompletedDescription:
			'لقد واجهنا مشكلة أثناء معالجة الإيداع الخاص بك. يرجى التحقق من معلومات الدفع الخاصة بك والمحاولة مرة أخرى. إذا استمرت المشكل',
		contactUs: 'اتصل بنا',
		depositNotCompleted: 'لم تتم العملية بنجاح',
		depositNotCompletedDescription:
			"يرجى التحقق من معلومات الدفع الخاصة بك و المحاولة مرة أخرى. يمكنك ايضاً اختيار مزود دفع آخر. إذا استمرت المشكلة، يرج <a href='https://cabinet.tvmarkets.com/ar/cabinet/console/contact_us'> التواصل معنا.</a>",
		depositWithClick: 'أو قم بالإيداع عبر آبل باي',
		keepInMind: 'Keep in mind',
		keepInMindTC: '',

		ltd: {
			depositDisclaimer:
				'يمكن أن تتجاوز الخسائر المبلغ المستثمر في البداية. لن يتم قبول الودائع من أطراف ثالثة. يجب أن تتم جميع الودائع من قبل صاحب الحساب. فئة التداول على المنصة هي الدولار الأمريكي. تحتفظ Tradeview Ltd. بالحق في إعادة/استرداد الودائع التي تتم عن طريق بطاقات الائتمان بدلاً من معالجة السحب.',
		},
		latam: {
			depositDisclaimer:
				'هي الدولار الأمريكي. تحتفظ Tradeview Financial Markets S.A.C. بالحق في إعادة/استرداد الودائع التي تتم عن طريق بطاقات الائتمان بدلاً من معالجة السحب.',
		},
		accountNumberTitle: 'رقم حساب التداول',
		accountNumberDescription: 'اختر الحساب الذي تريد الإيداع فيه',
		currencyTitle: 'نوع العملة',
		currencyDescription: 'يرجى اختيار أحد الخيارات',
		amountTitle: 'المبلغ',
		amountDescription: 'ادخل المبلغ المراد سحبه',
		phoneNumberTitle: 'رقم الهاتف',
		confirmTitle: 'راجع تفاصيل المعاملة',
		confirmDescription: 'تأكد من أن تفاصيل الإيداع التالي صحيح:',
		upholdCommission:
			'يرجى العلم أن العملاء هم من يتحملون مسئولية تغطية رسوم معاملات العملات الرقمية. كما أن قيمة الرسوم تعتمد على المبلغ المحول.',
		upholdBanningTitle: 'المناطق الجغرافية غير المدعومة',
		upholdBanningDescription:
			'نظرًا لقوانين الولايات المتحدة، لا تقدم Uphold خدماتها للمقيمين في البلدان التالية:',
		depositAmount: 'أدخل مبلغ الإيداع الخاص بك.',
		btcAlertTitle: 'رسوم إيداع BTC',
		btcAlertMessage:
			'سيتم تطبيق رسوم تحويل BTC إلى العملة الورقية على جميع الصفقات. تبلغ الرسوم 1٪ للصفقات التي تصل إلى 250 ألف دولار و1.5٪ للصفقات التي تتجاوز 250 ألف دولار.',
		upholdWarningTitle: 'عمولات إيداع العملات الرقمية',
		upholdWarningMessage:
			'رسوم تحويل BTC Fiat تبلغ 1% لجميع التداولات التي تصل إلى 250 ألف دولار أمريكي، و1.5% لجميع التداولات التي تزيد عن 250 ألف دولار أمريكي',
		bitPayCommission:
			'رسوم معاملات العملات الرقمية يتحملها المستخدمون (القيم تعتمد على مبلغ التحويل).',
		bitPayWarningTitle: 'يتم فرض الرسوم التالية على إيداع العملات الرقمية:',
		bitPayWarningMessage:
			'رسوم الصرف: 1.05%, رسوم الشبكة: 0.0003 بيتكوين, رسوم السحب: 0.0003 بيتكوين.',
		bitpayFooterInfo:
			'يرجى الانتباه أن Tradeview ليست مسؤولة عن أي مكاسب أو خسائر في أسعار العملات الرقمية خلال المعاملات. ',
		interacFooterInfo:
			'تحتفظ Tradeview Financial Markets S.A.C. بالحق في إعادة / استرداد الودائع التي تمت عن طريق بطاقات الائتمان بدلاً من معالجة السحب',
		tetherWarningTitle: 'عمولات:',
		tetherWarningMessage:
			'عند إجراء إيداع باستخدام العملات الرقمية، فإن هناك رسوم تحويل تبلغ 0.7%.',
		copied: 'تم النسخ',
		tetherHashTitle: 'Hash',
		tetherHashDescription: 'ادخل رمز Hash',
		tetherTooltip:
			'يتكون رمز Hash من أرقام وحروف يتم إنشاؤها عشوائيًا من خلال التشفير.',
		netellerFooterInfo:
			'Tradeview Financial Markets S.A.C. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal',
		fasapayAccountTitle: 'حساب Fasapay',
		fasapayAccountDescription: 'أدخل معرف حساب FasaPay الخاص بك',
		jpayFooterInfo: 'سعر صرف العملات: 1 دولار أمريكي = 7 يوان صيني (RMB)',
		addressTitle: 'العنوان',
		zipCodeTitle: 'الرمز البريدي',
		zipCodeDescription: 'أدخل الرمز البريدي الخاص بك',
		countryTitle: 'الدولة',
		countryDescription: 'اختر بلدك',
		cityTitle: 'المدينة',
		cityPlaceholder: 'اختر مدينتك',
		skrillFooterInfo:
			'Tradeview Financial Markets S.A.C. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal',
		bitwalletFooterInfo:
			'يمكن أن تتجاوز الخسائر المبلغ المستثمر الأصلي. لن يتم قبول الودائع من طرف ثالث. يجب أن يتم جميع الودائع من قبل صاحب الحساب. يتم تداول المنصة بالدولار الأمريكي. تحتفظ Tradeview Ltd. بالحق في إرجاع/استرداد الودائع التي تتم عن طريق بطاقات الائتمان بدلاً من معالجة السحب.',
		clickBank:
			'انقر على اسمك البنك الذي تريد التعامل معه، من أجل بدء الإيداع من خلال منصته الخاصة. بمجرد اكتمال عملية التحويل، أرسل إيصال المعاملة إلى الوسيط. بعد التحقق من المعاملة من قبل الوسيط، سيتم إضافة أموالك مباشرة إلى حساب التداول الخاص بك. ',
		banks: 'الحوالات البنكية',
		processingTime: 'وقت المعالجة:',
		commision: 'العمولة: ',
		bankProcessingTime: 'وقت المعالجة: يوم إلى يومين عمل تقريبًا.',
		bankCommision: 'عمولة: لا',
		sameDay: 'خلال دقائق',
		depositInstructions:
			'تعليمات الإيداع هذه مخصصة فقط للمقيمين في جزر كايمان. إن كنت مقيم في بلد أخر، برجاء استخدام بنك بديل.',
		downloadInfo: 'تنزيل المعلومات',
		intermediaryBank: 'اسم البنك الوسيط',
		intermediarySwift: 'سويفت الوسيط',
		beneficiarySwift: 'سويفت المستفيد',
		beneficiaryBank: 'البنك المستفيد',
		paymentProvider: 'عنوان مزود الدفع',
		accountHolder: 'اسم صاحب الحساب',
		virtualIban: 'الآيبان الافتراضي',
		bic: 'BIC',
		createLiAcc: 'فتح حساب تداول حقيقي',
		waitTitle: 'تحميل صفحة ويب جديدة',
		waitDescription:
			'يرجى عدم إغلاق هذه النافذة. سيتم فتح صفحة ويب جديدة بشكل أوتوماتيكي لمواصلة عملية الإيداع. يمكنك تصفح الموقع أو الانتظار حتى الانتهاء من العملية.',
		depositTypeTitle: 'اختر طريقة الإيداع',
		depositTypeDescription: 'اختر طريقة الدفع والإيداع التي تفضلها',
		typeCash: 'الدفع النقدي',
		typeBankTransfer: 'اختر الحساب الذي تريد الإيداع فيه',
		countryBankTitle: 'طريقة الدفع',
		countryBankDescription: 'اختر طريقة دفع',
		minimumAmount: 'الحد  االحد الأدنى',
		maximumAmount: 'الحد الأقصى 50: ألف دولار',
		is: 'هو',
		pleaseNote: 'تنويه:',
		validateDeposit: `اضغط على اسم البنك الذي تريد تحويل الأموال إليه، و سوف يظهر لك البيانات التي سوف تستعملها لاتمام التحويل البنكي . بمجرد اكتمال عملية التحويل، يرجى إرسال إيصال المعاملة إلينا عبر الايميل التالي ar&#64;tvmarkets.com  بعد التحقق من المعاملة من طرفنا ، سيتم إضافة أموالك مباشرة إلى حساب التداول الخاص بك.`,
		withdrawalchooseMatch:
			'يجب أن تكون طريقة السحب التي ستختارها لاحقًا هي نفس طريقة الإيداع.',
		notResponsibleDuringTransactions:
			'تريد فيو ليست مسئولة عن أي مكاسب أو خسائر بسبب تغير أسعار الصرف أثناء المعاملات.',
		minDeposit: 'الحد الأدنى لمبلغ الإيداع لهذه الطريقة هو 100.00 دولار',
		creditCards: 'بطاقات الائتمان',
		cryptos: {
			comission: {
				title: 'عمولات:',
				text: 'لا تفرض Tradeview رسومًا على الإيداع. هناك رسوم صرف بنسبة 0.7% تفرضها معالجتنا.',
			},
			scanText1:
				'امسح رمز الاستجابة السريعة هذا باستخدام ميزة المسح في تطبيق التداول الخاص بك',
			scanText2: 'أو انسخ عنوان العملة الرقمية يدويًا أدناه:',
			copyText:
				'انسخ عنوان العملة المشفرة أدناه والصقه في تطبيق التبادل الخاص بك: ',
		},
		processTimeSameDay: 'خلال دقائق',
		processTimethreeDay: 'حتى 3 أيام',
		commisionYes: 'نعم',
		commisionNo: 'لا يوجد',
		onReviewTitle: 'الإيداع قيد المراجعة',
		onReviewText:
			'الإيداع الخاص بك الآن قيد المراجعة. سيتواصل فريقنا معك عبر البريد الإلكتروني بمجرد الانتهاء من عملية الإيداع.',
		bitPayFees: 'يتقاضى معالج التشفير الرسوم التالية:',
		bitPayExchange:
			'رسوم الصرف: 1.05% <br> رسوم الشبكة: 0.0003 BTC <br> رسوم السحب: 0.0003 BTC',
		minimumAndMaxiumAmountInterac:
			'الحد الأدنى 75 دولار كندي - الحد الأقصى 9,999 دولار كندي',
		minumumAndMaxiumAdversInterac:
			'يتطلب Interac حدًا أدنى للإيداع قدره 75.00 دولارًا. سيتم رفض أي أموال أقل من 75.00 دولارًا.',
		routingNumber: 'رقم التوجيه (ABA)',
		beneficiaryBankAddress: 'عنوان البنك المستفيد',
		beneficiaryAccountNumber: 'رقم حساب المستفيد',
		beneficiaryAccountName: 'اسم حساب المستفيد',
		paymentDetailsFFC: 'تفاصيل الدفع FFC',
		iban: 'رقم الأيبان',
		swiftBic: 'SWIFT/BIC',
		currencies: 'العملات',
		sortCode: 'رقم السويفت',
		entersortCode: 'ادخل رقم الفرز',
		beneficiary: 'المستفيد',
		beneficiaryIBAN: 'رقم الحساب/رقم الحساب المصرفي الدولي للمستفيد',
		cci: 'CCI',
		moreInformationTitle: 'مطلوب معلومات إضافية',
		moreInformationText:
			'عندما يصل إجمالي إيداعاتك إلى 25,000 دولار أمريكي أو أكثر، يلزم التحقق الإضافي لمرة واحدة. لإكمال إيداعك، يرجى النقر على "متابعة" وتقديم التفاصيل المطلوبة حول الوظيفة والمالية.',
		moreInformationTextLTD:
			"مطلوب تحقق إضافي لمرة واحدة. لإكمال الإيداع الخاص بك، يرجى النقر فوق 'متابعة' وتقديم التفاصيل المطلوبة عن العمل والشؤون المالية.",
		selectMethod: 'اختر وسيلة الدفع',
		cryptoMena: 'هذه المعلومات مطلوبة مرة واحدة فقط لمدفوعات العملات المشفرة.',
		noOptions: 'لا توجد خيارات متاحة',
		digitalWalletsDisclaimer:
			'• رجاء الوضع في الاعتبار اننا لا نقبل إيداعات من طرف ثالث. <br> • حسابات التداول بالدولار الأمريكي. <br>',
		continueWithMyExchangeApp: 'تابع مع تطبيق التبادل الخاص بي',
		continueWithPayX: 'تابع مع PAY X',
		orDepositDirectly: 'أو قم بالإيداع مباشرة:',
		maximumAmountPSE_COL:
			'بالنسبة لطريقة الدفع PSE، الحد الأقصى للمبلغ هو 600 دولار أمريكي.',
		swiffyFooterInfo:
			'تحتفظ شركة Tradeview Ltd. بالحق في إعادة/رد الودائع المُسدَّدة ببطاقات الائتمان بدلاً من تنفيذ السحب.',
		payWith: 'ادفع باستخدام',
	},

	//Email
	email: {
		company: 'أخبار الشركة',
		selectOne: "أخبار التداول (Surf's Up!)",
		selectTwo: "Surf's Up!",
		update: 'تحديث',
		manageSubscription: 'حدد رسائل البريد الإلكتروني التي تريد الحصول عليها:',
		dontReceiveEmails:
			'إن كنت لا ترغب في استقبال أي رسائل بريد إلكتروني من المصادر المذكورة أدناه، فما عليك سوى إلغاء تحديدها ثم الضغط على زر "تحديث".',
	},

	//password
	password: {
		title: 'تغيير كلمة المرور',
		subTitle:
			'لتغيير كلمة المرور الخاصة بك، يرجى طلب رمز لمرة واحدة إلى بريدك الإلكتروني.',
		request: 'طلب الرمز',
		submit: 'إرسال',
		code: 'الرمز',
		current: 'كلمة المرور الحالية',
		confirm: 'تأكيد كلمة المرور الجديدة',
		setPasswordPreference: 'إعدادات حسابك',
		mailingSubscriptions: {
			title: 'الاشتراك بالبريد الالكتروني',
			description:
				'اشترك لاستلام رسائل عبر البريد الالكتروني من هنا. احصل على تحديثات السوق والتحليلات الأساسية مباشرة في بريدك الالكتروني، وابقى على اطلاع بما يحدث في الأسواق.',
			subscriptionUpdated: 'تم تحديث اشتراكاتك بنجاح',
			subscriptionError: 'عذرًا! حدث خطأ ما، يرجى الاتصال بالدعم.',
		},
		passwordSettings: {
			title: 'إعدادات كلمة المرور الخاصة بك',
			description:
				'قم بالتحكم في إعدادات كلمة المرور الخاصة بك من أجل ضمان أمان حسابك. يمكنك تغييره من هنا في أي وقت.',
		},
		factor2Verification: {
			title: 'اضبط المصادقة الثنائية الخاصة بك',
			description:
				'يمكنك تعزيز أمن حسابك عن طريق إضافة هذا البروتوكول. امنع أي شخص من الدخول إلى حسابك عن طريق طلب رمز الأمان في كل مرة يتم تسجيل الدخول فيها.',
			firstStepTitle: 'خطوة 1: حمل تطبيق جوجل للمصادقة الثنائية',
			firstStepFirstParagraph:
				'قم بتنزيل تطبيق للمصادقة الثنائية على جهازك المحمول. نوصيك بتحميل تطبيق جوجل Google Authenticator من جوجل بلاي أو آب ستور.',
			firstStepSecondParagraph:
				'عند تشغيل المصادقة الثنائية، سيتطلب منك الأمر إدخال كلمة المرور الخاصة بك، والرمز الذي سيظهر في تطبيق المصادقة الخاص بك.',
			turnOn: 'تشغيل',
			secondStepTitle: 'خطوة 2: ادخل رمز المصادقة الخاص بك',
			scanQRCode: 'قم بمسح رمز الـ QR التالي باستخدام تطبيق المصادقة',
			enterCodeManually:
				'أدخل الرمز المكون من ستة أرقام الموضح في تطبيق المصادقة',
			invalidCode: 'الرمز الذي أدخلته غير صالح. برجاء المحاولة مرة أخرى.',
			authCompleted: 'لقد تم إكمال رمز المصادقة الخاص بك على منصتنا بنجاح.',
			disable: 'إلغاء',
			succesfullyActivatedAuth:
				'جيد جدًا. لقد اكتملت عملية المصادقة الثنائية بنجاح، والآن أنت تتمتع بطبقة أمان إضافية في حسابك. إن كنت لا ترغب في تفعيل هذه الإعدادات، برجاء الضغط على زر "إلغاء". ',
			deactivatedNotification:
				'لقد تم إلغاء المصادقة الثنائية على حسابك بنجاح.',
			insertCode: 'ادخل رمز المصادقة الثنائية',
			downloadAuth: 'حمل تطبيق جوجل للمصادقة الثنائية',
			enterAuthCode: 'ادخل رمز المصادقة الخاص بك',
			codeSuccess: ' تم قبول رمز المصادقة على منصتنا بنجاح',
		},
		accountPreferences: 'تفضيلات حسابك',
		changeYoutPassword: 'تغيير كلمة المرور',
		requestChangePassword:
			'برجاء إدخال الرمز لمرة واحدة الذي تم إرساله إلى بريدك الإلكتروني.  ',
		requestCode: 'طلب الرمز',
		didntGetIt: 'لم يصلك؟',
		tryAgain: 'برجاء إعادة المحاولة',
		enter6DigitCode: 'ادخل الكود المكون من 6 أرقام. مثال 123456',
		enterValidOTP: 'الرمز الذي أدخلته غير صالح. برجاء المحاولة مرة أخرى.',
		notYourCurrentPassword: 'هذه ليست كلمة المرور الحالية الخاصة بك',
		passwordConditions:
			'يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف إنجليزية على الأقل تتضمن حرفًا صغيرًا، حرفًا كبيرًا، رقمًا، و رمزا واحدًا على الأقل.  مثال على الرمز  !@#$%^&*',
		passwordsDontMatch:
			'كلمات المرور التي قمت بإدخالها غير متطابقة. برجاء التحقق وإعادة المحاولة مرة أخرى.',
		newPassword: 'كلمة المرور الجديدة',
		confirmPassword: 'تأكيد كلمة المرور',
		passwordSuccessfulyChanged: 'تم تغيير كلمة المرور الخاصة بك بنجاح!',
		sampleEmail: 'تم إرسال رمز لمرة واحدة فقط إلى',
		cantResendCode: 'لا يمكننا إعادة إرسال الرمز الخاص بك الآن. حاول مرة أخرى.',
		enterCurrentPassword: 'ادخل كلمة المرور الحالية',
		enterNewPassword: 'ادخل كلمة المرور الجديدة',
		enterConfirmNewPassword: 'أكد كلمة المرور الجديدة الخاصة بك',
		passwordUpdated: 'تم تغيير كلمة المرور الخاصة بك بنجاح!',
		successful2Factor: 'اكتملت عملية المصادقة الثنائية الخاصة بك بنجاح!',
		areYouSure: 'هل أنت متأكد أنك تريد إلغاء خدمة المصادقة الثنائية؟ ',
		changePasswordDescription:
			'قم بتغيير إعدادات حسابك، إدارة اشتراكاتك والتأكد من أمان حسابك.',
		errorCantNumber:
			'The phone number you enter must be between 7 and 15 digits',
	},

	//Contact
	contact: {
		requestCall: 'اطلب مكالمة هاتفية',
		phoneNumber: 'رقم الهاتف',
		preferedTime: 'الوقت المفضلe',
		selectPreferedTime: 'اختر الوقت الذي تفضله للاتصال بك',
		enterPhone: 'أدخل رقم الهاتف الخاص بك',
		knowMore: 'اعرف المزيد عن Tradeview',
		callSchedule: 'تمت جدولة مكالمتك الهاتفية',
		callScheduleDescription:
			'سنقوم بالاتصال بك قريبًا. برجاء العلم أن وقت الانتظار قد يستغرق 24 ساعة من طلبك، بدءًا من يوم العمل التالي.',
		failedToSchedule: 'لم نتمكن من حجز المكالمة الخاصة بك',
		contactUsErrorCall:
			'نأسف على إزعاجك. برجاء إعادة المحاولة مرة أخرى. في حالة استمرار المشكلة، برجاء اختيار أي خيار آخر للتواصل معنا.',
		weWillContactYou:
			'سيقوم أحد موظفينا بالاتصال بك خلال الإطار الزمني المحدد.',
		unableToContactYou:
			'للأسف، لا يمكننا جدولة اتصال هاتفي لك في الوقت الحالي. يرجى مراجعة المعلومات وإعادة المحاولة.',
		infoInvalid: 'المعلومات المقدمة غير صحيحة. يرجى مراجعتها وإعادة المحاولة.',
		inNeedOfHelp: 'هل أنت بحاجة إلى المساعدة؟ نحن هنا لمساعدتك!',
		inNeedOfHelpDescription:
			'أيًا كان ما تريد فنحن هنا لمساعدتك. تواصل معنا إن كنت تريد أي تحديثات بشأن طلباتك، أو إن كان لديك أية استفسارات حول حساباتك. ',
		chatDescription: 'تريد الدردشة؟ سنجيبك فورًا',
		chatDescription1:
			'موظفونا متواجدون على مدار الساعة من الاثنين الي الجمعه من كل أسبوع',
		mailForward:
			'غير مستعجل؟ ارسل لنا بريد إلكتروني به كل أسئلتك واستفساراتك، وسنقوم بالرد عليك في أسرع وقت ممكن.',
		emailUs: 'ارسل بريد إلكتروني',
		letsChat: 'ابدأ الدردشة',
		scheduleACall: 'جدول مكالمة هاتفية',
		contactDisclaimer:
			'يمكنك التواصل معنا مباشرة عبر الهاتف المحمول على 34647457649+ أو عبر البريد الإلكتروني على ar&#64;tvmarkets.com',
		orVia: '',
		contactDisclaimerLatam:
			'إذا كنت تفضل، يمكنك الاتصال بنا مباشرة عبر البريد الإلكتروني على',
		stayConnected: 'كن على تواصل معنا',
		timeZone: 'المنطقة الزمنية',
		selectTimeZone: 'اختر المنطقة الزمنية',
		customDate: 'أريد اختيار يوم وميعاد',
		soonAsPossible: 'في أسرع وقت ممكن',
		callWhen: 'متى تريد أن نتصل بك؟',
		contactHelper:
			'يرجى العلم أنه في حالة اختيار "في أسرع وقت ممكن"، فسنتصل بك خلال 24 ساعة من طلبك اعتبارًا من يوم العمل التالي.',
		selectDate: 'اختر تاريخ',
		selectTime: 'اختر وقت',
		selectOption: 'يرجى اختيار أحد الخيارات',
		preferredDate: 'التاريخ المفضل',
		sendEmail: 'أرسل لنا بريدا إلكترونيا',
		subject: 'الموضوع',
		describeEmail: 'صف الغرض من بريدك الإلكتروني',
		concerns: 'رجاء كتابه أي تساؤلات لديك هنا. مع الشكر',
		yourMessage: 'رسالتك',
		emailSuccessful:
			'تم تسليم بريدك الإلكتروني بنجاح! سنعاود الاتصال بك في أقرب وقت ممكن.',
		emailSuccessfulTitle: 'تم إرسال بريدك الإلكتروني',
		emailErrorfulTitle: 'مشكلة في إرسال البريد الإلكتروني',
		emailErrorMessage:
			'نعتذر عن الإزعاج. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة ، فلا تتردد في استخدام أي خيار آخر متاح للتواصل معنا.',
		japanNotice: '',
		messageError: 'لا يمكن أن تتجاوز الرسالة 900 حرف',
		messageErrorShort: 'يجب أن يتكون الموضوع من 15 أحرف على الأقل',
		titleError: 'لا يمكن أن يتجاوز الموضوع 60 حرفا',
		titleErrorShort: 'يجب ألا يقل طول الموضوع عن 4 أحرف',
		preferredDate: 'التاريخ المفضل',
		failedAttempt: 'من فضلك، نهدف إلى المزيد من الوقت',
		callDate: 'تم حجز مكالمتك بنجاح',
		contactSetDate:
			'سيتواصل أحد موظفينا معك خلال التاريخ والوقت الذي قمت باختيارهما: ',
		errorPhoneNumber: 'لا يمكن أن يحتوي رقم الهاتف على حروف أو رموز',
		callDescription:
			'هل ترغب في التحدث مع أحد موظفينا؟ نقدر قيمة وقتك الثمين. احجز وقتًا مناسبًا لك! ',
		whatsAppDescription:
			'هل ترغب في الدردشة عبر الواتساب؟ سنرد عليك فورًا. موظفونا متواجدون على مدار الساعة من الإثنين إلى الجمعة كل أسبوع.',
		whatsAppChat: 'تواصل معنا عبر الواتساب',
		errorCantNumber:
			'The phone number you enter must be between 7 and 15 digits',
	},

	//menu
	menu: {
		appli: 'التطبيقات',
		account: 'الحسابات',
		platforms: 'تحميل',
		history: 'السجل',
		deposit: 'إيداع الأموال',
		transfer: 'التحويل',
		withdraw: 'السحب',
		tradingTools: 'أدوات التداول',
		settings: 'الإعدادت',
		passwordsettings: 'إعدادات كلمة المرور',
		emailsettings: 'إعدادات البريد الإلكتروني',
		authenticationsettings: 'إعدادات المصادقة',
		contactUs: 'اتصل بنا',
		accessDemo: 'دخول حساب العرض التجريبي',
		accessRestricted: 'الدخول محدود',
		btnReSubmit: 'إعادة تقديم المستند',
		temporarilyUnavailable: 'هذه الميزات غير متوفرة مؤقتاً',
		sorryFeature:
			'نعتذر، ولكن الميزات التي تحاول الوصول إليها غير متوفرة بعد. بمجرد إتمام عملية التقديم الخاصة بك وتفعيل حسابك، ستتمكن من الوصول إليها.',
		btnContinue: 'متابعة',
		liveFeature: 'هذه هي ميزات الحساب الحي',
		featureOnly:
			'الميزات التي تحاول الوصول إليها متوفرة فقط للحسابات الحية. أنشئ حساباً حياً الآن للحصول على الوصول.',
		call: 'لا وقت للتأخير؟ فريق الدعم لدينا متاح عبر الهاتف طوال الأسبوع من الساعة 5 صباحاً حتى 5 مساءً بتوقيت جرينيتش.',
		chat: 'تفضل الدردشة؟ دعنا نفعل ذلك. وكلائنا متاحون على مدار الساعة طوال أيام العمل في الولايات المتحدة.',
		mail: 'ليس مستعجلاً؟ أرسل لنا بريدًا إلكترونيًا، وسيقوم خبراؤنا بالرد عليك.',
		call2: 'اتصل بنا',
		chat2: 'الدردشة معنا',
	},

	//sidebar applications process
	sidebar: {
		help: 'بحاجة إلى مساعدة؟',
		call: 'اتصل بنا',
		chat: 'دردش معنا',
		mail: 'أرسل لنا بريد إلكتروني',
		notReady: 'هل انت بحاجة إلى مزيد من الوقت قبل فتح حساب حقيقي؟',
		btnDemo: 'فتح حساب تجريبي',
	},

	//form signature
	formSignature: {
		authorised: 'توقيع العميل المعتمد, قم بالتوقيع أعلاه.',
		or: 'أو',
		accept: 'تأكيد التوقيع',
		error1: 'لم تقم بتأكيد التوقيع، من فضلك أكده.',
		drop: 'قم بإسقاط الملفات الخاصة بك هنا،',
		browse: 'اختر من جهازك',
		make: 'تأكد من أن الملف بتنسيق JPEG أو PNG أو PDF وأن حجمه لا يتجاوز 3 ميجابايت.',
		error_help: 'لم تقم بتحميل الملف الذي يحمل توقيعك، من فضل حمله.',
	},

	//Text of application process form
	applicationForm: {
		duplicateShareholder:
			'A shareholder with this name and last name already exists.',
		duplicateEmail: 'A shareholder with this email already exists.',
		details: 'Details',
		idVerification: 'ID verification',
		proofResidence: 'Proof of residence',
		proofResidenceConsent: 'Proof of residence and consent',
		consent: 'Consent',
		liveIndividual: 'حساب فردي مباشر',
		liveJointAccount: 'حساب شركة ',
		primaryAccountHolder: 'صاحب الحساب الأساسي',
		title: 'المعلومات الشخصية',
		subtitlePlatform:
			'بعد إنشاء حسابك الأول مع  Tradeview، بإمكانك فتح المزيد من الحسابات لأصول مختلفة دون الحاجة إلى إعادة ملء النموذج بالكامل مرة أخرى.',
		subtitleDocument: 'ما نوع الوثائق التي ترغب في استخدامها للتحقق؟',
		subtitleResidence: 'ما هو نوع إثبات الإقامة الذي ترغب في استخدامه للتحقق؟',
		subtitleExperience:
			'اختر الخيار الذي يمثل تجربتك في تداول الفوركس أو الأسهم أو المشتقات أو عقود الفروقات بأفضل شكل',
		submitContact: 'اتصل بنا',
		drop: 'قم بتحميل الملفات الخاصة بك هنا أو',
		browse: 'اختر من جهازك',
		make: 'تأكد من أن صيغة الملف JPEG أو PNG أو PDF وأن حجمه لا يتجاوز 3 ميجابايت.',
		makeMaxSize:
			'تأكد من أن صيغة الملف JPEG أو PNG أو PDF وأن حجمه لا يتجاوز 15 ميجابايت.',
		tryAgain: 'برجاء إعادة المحاولة',
		openFile: 'المستند',
		submitted: 'تم تقديم طلبك بنجاح! جاري مراجعة طلبك',
		thankyou:
			'نشكرك على تقديم طلبك لفتح حساب معنا. طلبك الآن قيد المراجعة و سيتم التحقق منه قريباً.',
		operations:
			'  سيقوم أحد ممثلي فريق الدعم العربي بالتواصل معك إن كنت لا تزال بحاجة إلى تقديم بعض المستندات الإضافية. نشكركم مرة أخرى لاختياركم لشركة تريدفيو.',
		appreciate: 'نقدر رغبتك في الاشتراك معنا، وسنكون على تواصل قريبًا. ',
		gotocabinet: 'الذهاب إلى منطقه العملاء',
		explore: 'تعرف على Tradeview',
		acknowledgementText:
			'بالتوقيع أدناه، أقر وأوافق على صحة المستندات المقدمة في الخطوة السابقة. ',
		acknowledgementTextLATAM:
			'يرجى مراجعة وفهم كل عنصر في هذه الصفحة بعناية قبل تحديد مربعات الاتفاق والتوقيع.',
		jointConsent:
			'بعد الاطلاع على الاتفاقيات يرجى الضغط على مربعات الإقرار أدناه وتقديم توقيعك و الضغط على "قدم طلبك" لاتمام اجراءات فتح الحساب .',
		jointConsent:
			'بعد الاطلاع على الاتفاقيات يرجى الضغط على مربعات الإقرار أدناه وتقديم توقيعك و الضغط على "قدم طلبك" لاتمام اجراءات فتح الحساب .',
		secondaryAccount: 'إضافة حامل ثانوي',
		secondaryAccountDesc:
			'لإنهاء إعداد الحساب، من الضروري إنشاء صاحب الحساب الثاني.',
		primaryAccountHolder: 'صاحب الحساب الأساسي (أنت):',
		secondaryAccountHolder: 'صاحب الحساب الثانوي:',
		corporateResol: 'القرارات المؤسسية للشركة',
		corporateResolDisclaimer:
			'لرفع الملف، قم بإسقاط الملف في المكان المخصص أو ارفعه من جهازك.',
		corporateResolDisclaimer2:
			'تأكد من أن صيغة الملف JPEG أو PNG أو PDF وأن حجمه لا يتجاوز 3 ميجابايت.',
		corporateResolDesc:
			'يمكنك تنزيل وتعبئة نموذج القرار المؤسسي القياسي من Tradeview من خلال النقر على {link}، أو يمكنك تقديم نموذجك الخاص.',
		shareHolder: 'إضافة المساهمين في الحساب',
		shareHolderDesc:
			'يمكن إضافة ما يصل إلى 9 مساهمين، لدى كل منهم حصة لا تقل عن 10%، أو يمكنك تخطي هذه الخطوة إن كانت شركتك بدون مساهمين.',
		addShareholder: 'اضف مساهم جديد',
		or: 'أو',
		completeShareholder: 'أكمل تفاصيل المساهم',
		shareholder: 'المساهم',
		information: 'معلومات',
		aboutToComplete: 'أنت على وشك إكمال معلومات المساهم رقم #{number}',
		noShareAvailable:
			'لا يمكن أن تتجاوز النسبة المئوية المجمعة للمساهمين وصاحب الحساب 100%. يرجى المحاولة مرة أخرى.',
		percentageLow:
			'يجب أن تكون النسبة المئوية المجمعة للمساهمين وصاحب الحساب 100%. يرجى التحقق.',
		aboutToCompleteDesc:
			'قبل البدء، حضّر المستندات التالية للمساهم رقم #{number}:',
		accountHolderDisclaimer:
			'بالنسبة للمساهمين الذين يمتلكون أكثر من {percentage} من الشركة، نطلب المعلومات الشخصية، الهوية، وإثبات العنوان. من المساهمين الذين يمتلكون أقل من {percentage}، نطلب فقط الاسم واللقب.',
		deleteShareholder:
			'لتحرير الأسهم أو تحميل هوية المساهم وإثبات العنوان، يجب حذف الإدخال الحالي وإضافته مرة أخرى.',
		sendInvitation: 'إرسال الدعوات',
		pendingShareholderTitle: 'Missing shareholder information',
		pendingShareholderDesc:
			'You have incomplete shareholder details. To continue, please provide the required information for each shareholder.',
		inviteSentSuccess: 'تم إرسال الدعوة بنجاح',
		inviteSentSuccessDesc:
			'تتبع تقدم الطلب لكل مساهم في قسم معلومات المساهمين.',
		primaryHolder: 'صاحب الحساب (أنت)',
		sharePercent:
			'الحصة هي نسبة مئوية لملكية المساهم في الشركة. يتم تخصيص هذه النسب لتحديد ملكية كل مساهم في الشركة.',
		accountHolder: 'صاحب الحساب (أنت)',
		shareHolderDetails: 'تفاصيل المساهم {user}:',
		continueNoShareholder: 'كشف حساب بنكي للشركة',
		infoSwitchOff:
			'تأكد من أن المعلومات الواردة في المستند واضحة ومفهومة. وحاول تحميل أي مستندات لديك حاليًا. إن لم تكن الوثائق مكتملة، فيمكنك تحميلها وإرسالها في وقت لاحق عند الطلب. ',
		fileNotValid: 'برجاء تحميل ملف بصيغة وحجم مناسبين.',
		resolUpload:
			'تأكد من أن المعلومات والصور الموجودة في الملف واضحة ومفهومة. <br/><br/>لا تتردد في تحميل المستندات التي لديك في الوقت الراهن. لا تقلق إذا كان البعض مفقودًا؛ يمكنك تحميلها أو إرسالها لاحقًا عند الطلب. ',

		upDocument: 'تحميل المستند',
	},

	expiredDocument: {
		resubmit: 'قم بتحميل وثائق تحقيق الهوية',
		settingsDesc:
			'يرجى تحميل وثائق تحقيق الهوية حتى تستمر في استعمال كافة مزايا و خدمات لوحة التحكم.',
		resubmitDesc:
			'انتهت صلاحية مستندات التحقق الخاصة بك. يرجى تحميل ملف جديد الآن أو في غضون الأيام {days} القادمة في إعدادات الكابينة. إذا فشلت في القيام بذلك، لن تتمكن من التحويل أو السحب أو الإيداع حتى يتم التحديث.',
		idRefinitiv: 'أي طريقة تحقق من الهوية ترغب في استخدامها؟',
		idRefinitivDesc:
			'تحديث هويتك ببطاقة هوية صادرة عن الحكومة يضمن أمان وحسن نية حسابك.',
		idTooltip:
			'اختر كيف ترغب في إكمال التحقق من الهوية. يمكنك مسح رمز الاستجابة السريعة بهاتفك أو فتح علامة تبويب جديدة على الكمبيوتر الخاص بك. اختر الطريقة المفضلة أدناه.',
		cancelModal: 'هل أنت متأكد من أنك تريد المغادرة؟',
		cancelModalDesc:
			'يرجى تذكر، يجب إكمال هذه الخطوة في غضون {days} يومًا القادمة. إذا لم تقم بذلك، فلن تتمكن من الوصول إلى وظائف السحب والإيداع والتحويل في الكابينة الخاصة بك حتى يتم تحديث المستندات المطلوبة.',
		accessRestricted: 'الوصول مقيد',
		uploadDocs: 'قم بتحميل وثائق تحقيق الهوية',
		resubmitDocs: 'إعادة تقديم المستندات',
		accountholderId: 'اثبات الهوية',
		accountholderPoa: 'إثبات محل الإقامة',
		companyPoa: 'Company proof of address',
		companyPoaDesc:
			"Confirm your company's location to ensure compliance with regulatory standards.",
		restrictedID:
			'احظنا خلال عملية فحص عشوائية أن بطاقة الهوية التي قدمتها انتهت صلاحيتها. لضمان أمان حسابك، قمنا بحظر وظائف التحويل والسحب والإيداع مؤقتًا',
		restrictedID2:
			'يرجى تحميل بطاقة هوية جديدة الآن لاستعادة الوصول والاستمرار في التمتع بتجربة سلسة في الكابينة الخاصة بك.',
		restrictedPOA:
			'احظنا خلال عملية فحص عشوائية أن إثبات العنوان الذي قدمته قد انتهت صلاحيته. لضمان أمان حسابك، قمنا بحظر وظائف التحويل والسحب والإيداع مؤقتًا',
		restrictedPOA2:
			'يرجى تحميل إثبات عنوان جديد الآن لاستعادة الوصول والاستمرار في التمتع بتجربة سلسة في الكابينة الخاصة بك.',
		restrictedBoth:
			'لاحظنا خلال عملية فحص عشوائية أن بطاقة الهوية وإثبات العنوان المقدمة قد انتهت صلاحيتها. لضمان أمان حسابك، قمنا بحظر وظائف التحويل والسحب والإيداع مؤقتًا.',
		restrictedBoth2:
			'يرجى تحميل ملفات جديدة الآن لاستعادة الوصول والاستمرار في التمتع بتجربة سلسة في الكابينة الخاصة بك.',
		restrictedLimited:
			'حتى يتسنى لنا تفعيل حسابك و التحقق من هويتك, برجاء تحميل وثائق الهوية .',
		confirmationLimited:
			'يرجى تذكر إكمال هذه الخطوة. إذا لم تفعل ذلك، فسيظل حساب التداول الخاص بك معطلًا حتى يتم رفع المستندات الخاصة بك.',
		alertExpiredDocsSuccess:
			'لقد تم إرسال مستندك بنجاح. إنه قيد المراجعة حاليًا. إذا كانت هناك حاجة إلى أي مستندات إضافية، سيتواصل معك فريقنا.',
		alertExpiredDocsError:
			'يرجى رفع مستندات جديدة الآن أو خلال الأيام الـ {days} القادمة.',
		alertMissingDocsError:
			'يرجى تحميل وثائق التحقق من الهوية الخاصة بك لاكمال اجراءات التسجيل لفتح حساب تداول حقيقي.',
		submitDoc: 'اضغط لتحميل الوثائق',
		idverseD:
			'التحقق من الهوية هو جزء هام من عملية فتح الحساب ويضمن أعلى معاملات الأمان للجميع. نشكرك لتعاونك معنا',
		idverseT:
			'اختر الطريقة التي التي تفضلها لإتمام عملية التحقق من هويتك بها. يمكنك مسح رمز الQR code باستخدام هاتفك لإرسال رابط إلى هاتفك عبر الرسائل النصية القصيرة، أو الاستمرار على جهازك الحالي.',
	},

	//Aplication Process refinitiv
	appliProcessIDverse: {
		QRdescription: 'استخدم كاميرا هاتفك لمسح رمز الاستجابة السريعة.',
		IDVerseTitle: 'ما هي طريقة التحقق من الهوية التي تود استخدامها؟',
		IDVerseTitleLatam:
			'اختر الطريقة التي تفضل إتمام عملية التحقق من هويتك بها:',
		IDVerseTitleManualDoc:
			'اختر الطريقة التي تفضل إتمام عملية التحقق من هويتك بها:',
		IDVerseTitleManualDocTitle: 'اختر نوع المستند',
		IDVerseTitleManualDocDesc:
			'يرجى اختيار نوع المستند الذي ترغب في استخدامه للتحقق:',
		IDVerseTitleManualDocMainDesc:
			'التحقق من الهوية هو جزء هام من عمليه فتح الحساب ويضمن أعلي معاملات الأمان للجميع. نشركك لتعاونك معنا.',
		IDVerseDesc:
			'للحصول على تجربة أكثر سلاسة، نوصي بإكمال هذه الخطوة على هاتفك باستخدام إحدى الخيارات التالية:',
		or: 'أو',
		verifyOnNewTab: 'قم بتأكيد هويتك في علامة تبويب جديدة',
		sendLinkSms: 'أرسل رابطًا عبر رسالة نصية',
		verifyPopupConfig:
			'يرجى التأكد من تعطيل مانع النوافذ المنبثقة في متصفحك. لمزيد من المعلومات.',
		clickHere: 'انقر هنا.',
		alertDetail:
			'يرجى ملاحظة أنه يمكنك الوصول إلى عملية التحقق مرة واحدة فقط لكل رابط فريد. إذا كنت بحاجة للوصول إليها مرة أخرى، يرجى تحديث الصفحة ثم الضغط على طريقة التحقق المفضلة لديك.',
		alertDetailMobile: `يرجى ملاحظة أنه يمكنك الوصول إلى عملية التحقق مرة واحدة فقط لكل رابط فريد. لإكمال عملية التحقق، يرجى تحديث الصفحة ثم الضغط على "تحقق من هويتي". إذا كنت قد أكملت العملية بالفعل، اضغط على "متابعة". `,

		//Modal Verify Identity
		modalVerifyTitle: 'تحقق من هويتك',
		btnVerifyID: 'تحقق من هويتي',
		modalVerifyDesc1: 'للمتابعة، يجب عليك إتمام عملية التحقق من الهوية.',
		modalVerifyDesc2:
			'إذا كنت قد أتممت العملية بالفعل وما زلت غير قادر على المتابعة، يرجى الاتصال بنا في أقرب وقت ممكن.',
		modalVerifyButton: 'اختر طريقة التحقق من الهوية',
		//Skip step
		modalSkipTitle: 'هل أنت متأكد أنك تريد تخطي هذه الخطوة؟',
		modalSkipDesc1:
			'يمكنك تخطي هذه الخطوة مؤقتًا وإكمالها لاحقًا من خلال لوحة العميل الخاصة بك، أو اختيار طريقة للتحقق من الهوية الآن لإنهاء العملية.',
		modalSkipDesc2: ' يرجى ملاحظة أن إتمام هذه الخطوة ضروري لتفعيل حسابك.',
		btnVerifyAddress: 'تحقق من عنواني',
		btnVerifyIdentity: 'تحقق من هويتي',
		btnSkip: 'تخطي الآن',
		modalSendSMSChangeNumberTitle: 'رجاء أدخال رقم هاتف جديد',
		modalSendSMSChangeNumberDesc:
			'أدخل رقم الهاتف الذي تود استقبال رابط التحقق من الهوية من خلاله:',
		modalSendSMSChangeNumberButton: 'إرسال',
		modalSendSMSChangeNumberCancel: 'إلغاء',
		modalSendSMSChangeNumberCheck: 'قم بحفظ الرقم هذا كرقمي المسجل معكم',
		modalSendLinkSMSFailedTitle: 'حدث خطأ',
		modalSendLinkSMSFailedDesc:
			'تعذر علينا إرسال الرابط عبر الرسائل النصية. يرجى التحقق من الرقم والمحاولة مرة أخرى.',
		modalSendLinkSMSFailedButtonCancel: 'إلغاء',
		modalSendLinkSMSFailedButtonChangeNumber: 'تغيير الرقم',
		modalSendLinkSMSTitle: 'تم أرسال الرابط عبر رسالة أسم أم اس',
		modalSendLinkSMSDesc:
			'تم أرسال رابط الي رقم الجوال المسجل على الحساب. رجاء فتح الرابط على الهاتف الخاص بك وأتباع إجراءات التحقق من الحساب.',
		modalSendLinkSMSButtonReSend: 'إعادة الإرسال',
		modalSendLinkSMSButtonOkay: 'نعم',
		clickHere: 'أضغط هنا ',
		or: 'أو',
		modalSendLinkSMSOptionalNumber: 'رجاء الأرسال الي رقم هاتف أخر',
		uploadCurrentDevice: 'لتحميل الوثيقة من جهازك الحالي.',
		retryIn: 'يرجى المحاولة مرة أخرى خلال',
		chooseTooltip:
			'اختر الطريقة التي تفضل إتمام عملية التحقق من هويتك بها. يمكنك مسح رمز الاستجابة السريعة باستخدام كاميرا هاتفك، إرسال الرابط إلى هاتفك عبر الرسائل النصية القصيرة، أو الاستمرار على جهازك الحالي.',
		sendToDifferentNumber: 'رجاء الأرسال الي رقم هاتف أخر',
		chromeInstructions: {
			step1: 'انتقل إلى الإعدادات',
			step2:
				'انتقل إلى الخصوصية والأمان > إعدادات الموقع > النوافذ المنبثقة وإعادة التوجيه',
			step3: 'قم بإيقاف تشغيل خيار "حظر"',
		},
		safariInstructions: {
			step1: 'انتقل إلى Safari > تفضيلات',
			step2: 'حدد المواقع الإلكترونية > النوافذ المنبثقة',
			step3: 'قم بتعديل الإعدادات حسب الحاجة',
		},
		firefoxInstructions: {
			step1: 'انقر على رمز القائمة.',
			step2: 'انتقل إلى التفضيلات > الخصوصية والأمان > الأذونات.',
			step3: 'قم بتعديل إعدادات النوافذ المنبثقة حسب الضرورة.',
		},
		assistanceText: `إذا واجهت أي صعوبات، يرجى`,
		assistanceText2: `التواصل معنا للحصول على المساعدة.`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: 'حساب شركة',

		//Company details
		companyDetailsTitle: 'بيانات الشركة',
		nameLabel: 'اسم الشركة',
		namePlaceholder: 'ادخل اسم الشركة',
		businessTypeLabel: 'نوع العمل',
		businessTypePlaceholder: 'اختر نوع العمل',
		companyEmailLabel: 'البريد الإلكتروني للشركة',
		companyEmailPlaceholder: 'ادخل البريد الإلكتروني للشركة',
		companyEmailTooltip:
			'يتطلب التسجيل معنا إدخال بريد إلكتروني من أجل التحقق من شرعية حسابات الشركة والحفاظ على بيئة تداول آمنة. ',
		businessDescriptionLabel: 'وصف العمل التجاري',
		businessDescriptionPlaceholder: 'ادخل وصف مختصر عن الشركة وأعمالها.',
		businessDescriptionTooltip:
			'نطلب هذه المعلومات للتعرف بشكل أفضل على شركتك، الغرض منها ونطاق عملها. إن إدخال الوصف الصحيح يؤهل حسابك للموافقة عليه وتقديم خدمات مخصصة لتلبية احتياجات عملك.',

		//Company address
		companyAddressTitle: 'عنوان الشركة',
		companyAddressTitleTooltip: `يعني هذا البلد الذي تدير فيه نشاطك التجاري. تساعدنا هذه المعلومات على تقديم خدمات مخصصة بناء على متطلباتك واللوائح التنظيمية لبلدك.إن لم تكن الدولة التي تتواجد بها شركتك موجودة ضمن قائمتنا، فيؤسفنا إبلاغك أننا غير قادرين على تقديمك خدماتنا في دولتك.
`,

		//Account ownership
		accountOwnershipTitle: 'معلومات ملكية الحساب',
		dateIncorporationLabel: 'تاريخ التأسيس',
		dateIncorporationTooltip:
			'هو التاريخ الذي تم تسجيل فيه شركتك بشكل رسمي. يساعد إدخال التاريخ في التحقق من وضعك القانوني والامتثال للقوانين التنظيمية.',
		countryOfRegistrationLabel: 'بلد التسجيل',
		countryOfRegistrationPlaceholder: 'اختر دولة',
		countryOfRegistrationTooltip:
			'هو البلد الذي تم تسجيل فيه شركتك بشكل رسمي. يساعد إدخال البلد في فهم طبيعة عملك، وضعك القانوني والامتثال للقوانين التنظيمية.',
		marketCapitalizationLabel: 'إجمالي القيمة السوقية أو صافي القيمة',
		marketCapitalizationPlaceholder: 'ادخل إجمالي القيمة السوقية لشركتك',
		marketCapitalizationTooltip:
			'تشمل القيمة السوقية الأسهم القائمة للشركة، بينما تمثل صافي القيمة، القيمة الإجمالية لأصول الشركة مطروحًا منها التزاماتها المالية.',
		isSubsidiaryLabel: 'إذا كانت شركة تابعة، برجاء تقديم اسم الشركة الأم',
		isSubsidiaryPlaceholder: 'ادخل اسم الشركة الأم',
		isIndividualRegularMemberLabel:
			'هل من يقوم بتقديم هذا الطلب هو موظف أو شريك في الشركة؟ أم أنه المالك للكيان المذكور؟',

		//Tax residency information
		taxResidencyTitle: 'إقرار الإقامة الضريبية الخاص بك',
		isUSCompanyLabel:
			'هل الشركة مصنفة أنها كيان أمريكي، أو أنها تخضع للضرائب في الولايات المتحدة؟',
		taxResidencyContryLabel: 'لأغراض ضريبية، أؤكد أنني مقيم في البلد التالي:',
		taxResidencyContryListLabel: 'الدولة',
		taxResidencyContryListPlaceholder: 'اختر دولة',
		taxResidencyReferenceCodeLabel: 'رمز الضريبة المرجعي ',
		taxResidencyReferenceCodePlaceholder: 'ادخل كودك الضريبي',
		modalRegulationP:
			'نحن نعتذر. بسبب اللوائح، لا يمكننا تقديم الخدمات للشركات التي تتواجد أو تُعتبر مقيمة ضريبيًا في الأراضي الأمريكية.',

		//Account type and platform information
		accountTypeTitle: 'نوع الحساب',

		// Financial details
		financialDetailsTitle: ' التفاصيل المالية',
		financialDetailsTooltip:
			'يجب عليك الكشف عن معلومات شركتك المالية من أجل تقييم المخاطر بشكل صحيح لكلا الطرفين (أنت وTradeview).',
		companyAnnualIncomeLabel: 'ما هو دخل شركتك السنوي؟',
		companyAnnualIncomeTooltip:
			'الدخل السنوي للشركة هو إجمالي إيراداتها خلال عام. ',
		companyTotalAssetsLabel: 'ما هو إجمالي مبلغ الأصول التي تمتلكها؟',
		companyTotalAssetsTooltip:
			'الأصول هي المدخرات والعقارات والاستثمارات الأخرى التي تمتلكها بعد خصم التزاماتك.',
		companyLiquidAssetsLabel: 'ما هي الأصول السائلة التي تمتلكها شركتك؟ ',
		companyLiquidAssetsTooltip:
			'الأصول السائلة، هي الأموال النقدية التي تمتلكها بعيدًا عن الأصول المجمدة.',
		companyOriginAssetsLabel: 'من أين حصلت على أصول الشركة؟',
		companySourceFundsLabel: 'ما هو مصدر أموال الشركة؟',
		companyPruoseAccountLabel: 'ما هو الغرض من فتح حساب تداول؟',
		companyIsConnectedBanktruptcies: 'هل هناك احتمالات لإعلان إفلاسك؟',
		companyIsConnectedBanktruptciesDetailsLabel: 'تفاصيل الإفلاس',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'إضافة معلومات عن احتمالات الإفلاس',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'يجب أن تكشف عن أي صلة لك بأي عمليات إفلاس محتملة، وذلك من أجل تقييم المخاطر لكلا الطرفين (أنت و Tradeview)ومع ذلك، اطمئن فحتى إذا كان هناك فرص لإفلاس محتمل، فمازال مرحبًا بك في مواصلة تقديم طلب فتح الحساب. ',

		//Proof of address
		proofAddressTitle: ' إثبات محل الإقامة',
		proofAddressTitleCorporate: 'إثبات عنوان الشركة',
		proofAddressDescription:
			'إثبت عنوان شركتك للتأكد من الامتثال للمعايير التنظيمية.',

		//Company Account Consent
		companyAccountConsentTitle:
			'شكرًا لمشاركة البيانات الخاصة بشركتك معنا. لنستكمل الآن الخطوة التالية!',
		companyAccountConsentDescription1:
			'الآن، نطلب منك ملء معلومات صاحب الحساب. يمكنك التعديل على المعلومات المقدمة في أي وقت من قائتمنا الموجودة على يمين الشاشة. ما عليك سوى الضغط على أيقونة التعديل (القلم) الموجودة بجوار كل معلومة تريد تغييرها. ',
		companyAccountConsentDescription2:
			'برجاء التأكد من رفع بطاقة هويتك التي تحمل صورتك، بالإضافة إلى إثبات محل الإقامة. أما المستندات الأخرى، فبإمكانك رفعها الآن أو إرفاقها لاحقًا عند الطلب. ',
		companyAccountConsentDocumentsTitle:
			'تأكد من أن المستندات التالية بحوزتك الآن وجاهزة للرفع:',
		companyAccountConsentDocumentsList1:
			'بطاقة هوية صادرة عن الحكومة تحتوي على صورة لحامل الحساب',
		companyAccountConsentDocumentsList2: 'إثبات إقامة لحامل الحساب',
		applicationFormAccountCheck:
			'*أوافق على السماح لشركة Tradeview Ltd بالتحقق من شخصيتي بصورة إلكترونية باستخدام معلوماتي الشخصية التي تتضمن اوراق الهوية الخاصة بي. سوف نقوم باستخدام أحد البرامج الآمنه للتحقق من الهوية و صحة المعلومات المقدمة من طرف العميل.',

		//Company Consent
		companyConsentTitle:
			'شكرا لاهتمامك بفتح <br> حساب مع تريد فيو! <br> فلنبدأ عملية فتح الحساب الآن',
		companyConsentDescription:
			'لإعداد حسابك المشترك، أنت بحاجة إلى تقديم بعض المعلومات.',
		companyConsentDocumentsTitle: 'قبل البدء، جهز الوثائق التالية:',
		companyConsentDocumentsOfCompanyTitle: 'الشركة:',
		companyConsentDocumentsList1: 'شهادة تسجيل الشركة',
		companyConsentDocumentsList2: 'إثبات عنوان الشركة',
		companyConsentDocumentsList3: 'كشف حساب بنكي للشركة',
		companyConsentDocumentsList4: 'البيانات المالية للشركة',
		companyConsentDocumentsList5: 'شهادة ضريبية للشركة',
		companyConsentDocumentsList6: 'هيكل ملكية الشركة',
		companyConsentDocumentsList7: 'التقرير السنوي للشركة',
		companyConsentDocumentsOfAccountHolderTitle: 'صاحب الحساب',
		companyConsentDocumentsOfAccountHolderList1: 'خطة عمل الشركة',
		companyConsentDocumentsOfAccountHolderList2: 'ترخيص الأعمال للشركة',
		companyConsentDocumentsOfShareholderTitle: 'المشارك في الحساب',
		companyConsentDocumentsOfShareholderList1: 'اتفاقية المساهمين في الشركة',
		companyConsentDocumentsOfShareholderList2: 'شهادة المساهمين في الشركة',
		companyConsentAdditionalInfoDescription:
			'بإمكانك تحميل المستندات التي لديك حاليًا، فقط نريد إثبات الهوية والعنوان لبدء عملية التحقق. إن كان لديك وثائق أخرى، فيمكنك تقديمها لاحقًا. ',
		applicationFormConsentCheck:
			'*أوافق على السماح لشركة Tradeview Ltd بالتحقق من شخصيتي بصورة إلكترونية باستخدام معلوماتي الشخصية التي تتضمن اوراق الهوية الخاصة بي. سوف نقوم باستخدام أحد البرامج الآمنه للتحقق من الهوية و صحة المعلومات المقدمة من طرف العميل.',

		//Account holder details
		accountHolderDetailsTitle: 'معلومات صاحب الحساب',
		accountHolderDetailsTooltip:
			'صاحب الحساب هو المسئول الرئيسي عن إدارة حساب الشركة. يمكن لهذا الشخص تنفيذ الصفقات، اتخاذ قرارات التداول، إضافة أو إزالة المشاركين في الحساب. تأكد من أن البيانات المقدمة صحيحة ودقيقة. ',

		//Account holder address
		accountHolderAddressTitle: 'عنوان صاحب الحساب',
		accountHolderAddressTooltip:
			'برجاء إدخال عنوان السكن أو العمل لصاحب الحساب، المخول له بإدارة حساب الشركة. هذه المعلومات خاصة بصاحب الحساب وليس الشركة نفسها.',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'برجاء إدخال إقرار الإقامة الضريبية لصاحب الحساب، المخول له بإدارة حساب الشركة. هذه المعلومات خاصة بصاحب الحساب وليس الشركة نفسها.',
		accountHolderTaxResidencyModalDescription:
			'نحن نعتذر. بسبب اللوائح، لا يمكننا تقديم الخدمات للشركات التي تتواجد أو للأشخاص المقيمين في الأراضي الأمريكية.',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'نريد أن نعرف أكثر عن تجربتك وخبرتك في التداول لمساعدتنا في تقديم دعم أكثر ملائمة لك سواء كنت متداول مبتدئ أو محترف. ',

		//Shareholder consent
		shareholderConsentTitle: 'شكرًا لك! تم استكمال بيانات صاحب الحساب بنجاح.',
		shareholderConsentDescription1:
			'نحن على وشك الانتهاء. نحتاج فقط إلى إدخال معلومات المساهمين.',
		shareholderConsentDescription2:
			'إذا لزم الأمر، يمكنك تعديل التفاصيل المقدمة سابقًا في أي وقت باستخدام قائمة التقدم على الجانب الأيمن من الشاشة. فقط انقر على رمز القلم بجانب المعلومات التي ترغب في تعديلها.',
		shareholderConsentDescription3:
			'تذكر أنه، بخلاف بطاقة الهوية الصادرة عن الحكومة وإثبات الإقامة، يمكنك رفع الوثائق الضرورية في الوقت الذي يناسبك—إما الآن أو لاحقًا عند الطلب.',
		companyConsentConsentDocumentsTitle:
			'قبل أن تبدأ، يرجى التأكد من أن لديك أو أن المساهمين لديهم الوثائق الإلزامية التالية جاهزة:',
		companyConsentConsentDescription1:
			'لقد اقتربنا! فقط أدخل معلومات المساهمين لإكمال العملية.',
		companyConsentConsentDescription2:
			'إذا لزم الأمر، يمكنك تعديل أي تفاصيل أدخلتها سابقًا بالنقر على أيقونة القلم في العمود الأيمن.',
		shareholderConsentDocumentsTitle:
			'تأكد من أن المستندات التالية بحوزتك الآن وجاهزة للرفع:',
		shareholderConsentDocumentsList1:
			'بطاقة هوية على أن تكون صادرة من جهة حكومية وبها صورة المساهم',
		shareholderConsentDocumentsList2: 'إثبات محل إقامة المساهم',
		shareholderConsentDocumentsList3: 'التوقيع الرقمي',
		shareholderConsentCheck:
			'*أوافق على السماح لشركة Tradeview Ltd بالتحقق من شخصيتي بصورة إلكترونية باستخدام معلوماتي الشخصية التي تتضمن اوراق الهوية الخاصة بي. سوف نقوم باستخدام أحد البرامج الآمنه للتحقق من الهوية و صحة المعلومات المقدمة من طرف العميل.',

		//Application Submition
		applicationSubmitionTitle: 'إرسال الطلب',
		applicationSubmitionDescription1:
			'تطبيق حسابك المؤسسي يكاد يكتمل! نقدر الجهد المبذول في إتمام الطلب.',

		applicationSubmitedTitle: 'تم تقديم طلبك بنجاح! جاري مراجعة طلبك',
		applicationSubmitedDescription1:
			'شكرًا لتقديم طلب حسابك المؤسسي. طلبك قيد المراجعة الآن وسيتم التحقق منه قريبًا.',
		applicationSubmitedDescription2:
			'سيتواصل معك فريق العمليات لدينا إذا اخترت عدم رفع أي من الوثائق المطلوبة أثناء ملء المعلومات.',
		//Global
		selectOption: 'يرجى اختيار أحد الخيارات',
		accountOwnershipTooltip:
			'يعني هذا البلد الذي تدير فيه نشاطك التجاري. تساعدنا هذه المعلومات على تقديم خدمات مخصصة بناء على متطلباتك واللوائح التنظيمية لبلدك.إن لم تكن الدولة التي تتواجد بها شركتك موجودة ضمن قائمتنا، فيؤسفنا إبلاغك أننا غير قادرين على تقديمك خدماتنا في دولتك.',

		//Progress
		companyInformation: 'معلومات الشركة',
		companyAddressDetails: 'تفاصيل عنوان الشركة',
		companyOwnershipDetails: 'تفاصيل ملكية الشركة',
		companyDocuments: ' وثائق الشركة',
		accountConsent: 'موافقة الحساب',
		accountConsentCorporate: 'معلومات صاحب الحساب',
		tradingExperience: ' الخبرة في التداول',
		accountInformation: 'معلومات الحساب',
		tradingExperience: ' الخبرة في التداول',
		IDVerification: ' التحقق من الهوية',
		accSetupSubmision: 'إعداد الحساب وتقديمه',
		shareholderInformation: 'بيانات الشريك',
		shareholderConsent: 'موافقة المساهم',
		finish: 'إنهاء',
		addressDetails: 'تفاصيل العنوان',
		share: 'الحصص',

		//Shareholder consent
		welcomeShareholderConsentTitle: 'جاهز للانضمام إلى حساب شركة؟ ابدأ طلبك',
		welcomeShareholderConsentDescription1:
			'لإعداد حسابك المشترك، أنت بحاجة إلى تقديم بعض المعلومات.',
		shareholderConsentDocumentsTitle: 'قبل البدء، جهز الوثائق التالية:',
		welcomeShareholderConsentDocumentsList1:
			'هوية صادرة من جهة حكومية تحتوي على صورة شخصيه لك.',
		welcomeShareholderConsentDocumentsList2: ' إثبات محل الإقامة',
	},

	//disclaimer
	disclaimer: {
		secure1: 'معاملات',
		secure2: 'الامان والتشفير',
		secure3: '',
		term: 'الشروط والأحكام',
		privacy: 'سياسة الخصوصية',
		aml: 'سياسة مكافحة غسيل الاموال',
		withdrawal: 'سياسات السحب',
		refund: 'سياسات استرداد الأموال',
		risk: 'إخلاء المسئولية',
		title: 'إخلاء المسئولية',
		default: {
			description:
				'الخدمات والمنتجات التي تقدمها Tradeview Markets لا يتم تقديمها داخل الولايات المتحدة (الولايات المتحدة) ولا يتم تقديمها للأشخاص الأمريكيين، كما هو محدد بموجب القانون الأمريكي. المعلومات الموجودة على هذا الموقع ليست موجهة إلى المقيمين في أي دولة يتم فيها تقييد أو حظر تداول الفوركس وعقود الفروقات بموجب القوانين أو اللوائح المحلية. تعتبر عقود الفروقات أدوات مالية معقدة وتنطوي على مخاطر عالية بفقدان الأموال بسرعة بسبب الرافعة المالية. بين 74٪ و 89٪ من حسابات المستثمرين الأفراد يخسرون الأموال عند تداول عقود الفروقات. يجب أن تفكر فيما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كان يمكنك تحمل المخاطرة العالية بفقدان أموالك.',
		},
		ltd: {
			description:
				'الخدمات والمنتجات التي تقدمها Tradeview Ltd. لا يتم تقديمها داخل الولايات المتحدة (الولايات المتحدة) ولا يتم تقديمها للأشخاص الأمريكيين، كما هو محدد بموجب القانون الأمريكي. المعلومات الموجودة على هذا الموقع ليست موجهة إلى المقيمين في أي دولة يتم فيها تقييد أو حظر تداول الفوركس وعقود الفروقات بموجب القوانين أو اللوائح المحلية. تعتبر عقود الفروقات أدوات مالية معقدة وتنطوي على مخاطر عالية بفقدان الأموال بسرعة بسبب الرافعة المالية. بين 74٪ و 89٪ من حسابات المستثمرين الأفراد يخسرون الأموال عند تداول عقود الفروقات. يجب أن تفكر فيما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كان يمكنك تحمل المخاطرة العالية بفقدان أموالك.',
		},
		latam: {
			description:
				'الخدمات والمنتجات التي تقدمها Tradeview Financial Markets S.A.C. لا يتم تقديمها داخل الولايات المتحدة (الولايات المتحدة) ولا يتم تقديمها للأشخاص الأمريكيين، كما هو محدد بموجب القانون الأمريكي. المعلومات الموجودة على هذا الموقع ليست موجهة إلى المقيمين في أي دولة يتم فيها تقييد أو حظر تداول الفوركس وعقود الفروقات بموجب القوانين أو اللوائح المحلية. تعتبر عقود الفروقات أدوات مالية معقدة وتنطوي على مخاطر عالية بفقدان الأموال بسرعة بسبب الرافعة المالية. بين 74٪ و 89٪ من حسابات المستثمرين الأفراد يخسرون الأموال عند تداول عقود الفروقات. يجب أن تفكر فيما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كان يمكنك تحمل المخاطرة العالية بفقدان أموالك.',
		},
		mena: {
			description:
				'الخدمات والمنتجات التي تقدمها Tradeview Financial Markets S.A.C. لا يتم تقديمها داخل الولايات المتحدة (الولايات المتحدة) ولا يتم تقديمها للأشخاص الأمريكيين، كما هو محدد بموجب القانون الأمريكي. المعلومات الموجودة على هذا الموقع ليست موجهة إلى المقيمين في أي دولة يتم فيها تقييد أو حظر تداول الفوركس وعقود الفروقات بموجب القوانين أو اللوائح المحلية. تعتبر عقود الفروقات أدوات مالية معقدة وتنطوي على مخاطر عالية بفقدان الأموال بسرعة بسبب الرافعة المالية. بين 74٪ و 89٪ من حسابات المستثمرين الأفراد يخسرون الأموال عند تداول عقود الفروقات. يجب أن تفكر فيما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كان يمكنك تحمل المخاطرة العالية بفقدان أموالك.',
		},
	},

	//modal
	modal: {
		error: 'هل أنت أمريكي أو تقيم في الولايات المتحدة الأمريكية؟',
		description:
			'يؤسفنا ان نخبرك انه غير متاح قبول طلبك في الوقت الحالي نظرا لانك مقيم في الولايات المتحدة الامريكية. اذا كان لديك اي استفسار اخر تفضل بالتواصل معنا عبر الايميل التالي: ar&#64;tvmarkets.com',
		thank: '',
		btnRegulation: 'زيارة صفحة التنظيم والترخيص',
	},

	//tooltips
	tooltips: {
		signature1:
			'اختر الطريقة التي تقدم بها توقيعك. يكمنك التوقيع يدويًا بشكل مباشر من خلال أداة تفاعلية خاصة، أو يمكنك تحميل توقيعك. اختر من بين:',
		sourceAccount: 'الحساب الذي سيتم سحب الأموال منه.',
		sourceAccountTransfer: 'الحساب الذي سيتم تحويل الأموال منه.',
		currencyUSD: 'USD: الدولار الأمريكي',
		currencyEUR: 'EUR: اليورو',
		currencyJYP: 'JPY: الين الياباني',
		currencyCAD: 'CAD: الدولار الكندي',
		currencyGBP: 'GBP: الجنيه البريطاني',
		targetAccount: 'الحساب الذي سيتم تحويل الأمواله إليه.',
		digitalWallets:
			'نقدم في تريدفيو ماركتس مجموعة كبيرة من خيارات الإيداع. يرجى العلم أن الرسوم تختلف بحسب الطريقة التي تختارها.',
		wireTransfers:
			'في حالة اختيار هذه الطريقة للإيداع، ستكون بحاجة إلى اختيار البنك الذي تتعامل معه وتقديم المعلومات المطلوبة لعمل الإيداع. ستصل أموالك إلى حسابك بعد التحقق من هذه المعلومات. ',
		cardTransfers: 'نحن نقبل فيزا و ماستركارد و آبل باي في الايداعات.',
		currencyUphold: `العملة تشير إلى العملة الأساسية التي سينفذ بها حسابك التداولات. يتم تمثيلها باستخدام الاختصارات التالية:<br/>USD: الدولار الأمريكي' <br/>EUR: اليورو<br/>JPY: الين الياباني <br/>CAD: الدولار الكندي <br/>GBP: الجنيه البريطاني `,
		currencyType: 'العملة هي طريقة الدفع التي ستتعامل بها في حسابك.',
		leverageTM:
			'تمكنك الرافعة المالية من فتح مراكز أكبر برأس مال أقل، حيث تعمل على تضخيم رأسمالك. يتم التعبير عنها بنسب مثل 1:50 أو 1:100، مما يعني نسبة الرفع التي تستخدمها عند التداول.',
		demoXleverage: 'X-Leverage: 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: 'Stock: 1:1',
		notSureAccount: 'لا تعرف أي نوع حساب تختار؟',
		ltd: {
			withdrawCurrency:
				'اختر العملة الأساسية التي تريد التداول من خلالها في حسابك. يتم تمثيل العملات بالاختصارات التالية:<br><br> USD: الدولار الأمريكي <br> EUR: اليورو <br> GBP: الجنيه الإسترليني',
		},
		latam: {
			withdrawCurrency: 'العملة هي طريقة الدفع التي ستتعامل بها في حسابك.',
		},
		mena: {
			withdrawCurrency: 'العملة هي طريقة الدفع التي ستتعامل بها في حسابك.',
		},
	},

	//register
	register: {
		goBack: 'العودة إلى الخلف',
		titleRegister: 'تسجيل الحساب',
		AccountDesc:
			'مرحبًا بك في بوابة التداول الخاصة بنا! اختر بين حسابات التجريبي أو الحقيقي لبدء رحلة التداول الخاصة بك واكتشاف الفرق مع Tradeview.',
		AccountChoose: 'ما نوع الحساب الذي ترغب في إنشائه؟',
		dinamicDescLive:
			'لست مستعدًا بعد لحساب حقيقي؟ <spam>أنشئ حسابًا تجريبيًا.</spam>',
		dinamicDescDemo:
			'تريد التداول بحساب حقيقي بدلاً من ذلك؟ <spam>أنشئ حسابًا حقيقيًا</spam>',
		getYour: 'افتح حساب تداول حقيقي الآن!',
		or: 'أو سجل من هنا:',
		email: 'البريد الإلكتروني',
		secure: 'إنشاء كلمة المرور',
		confirmPassword: 'تأكيد كلمة المرور',
		disclaimer:
			'إخلاء المسئولية: قبل فتح حساب التداول، نحن في Tradeview Financial Markets S.A.C. ("Tradeview") نلتزم بالتحقق من أنك أو الشخص/ الأشخاص الذين تعينهم للتداول نيابة عنك لديكم المعرفة والخبرة الكافية في تداول عقود الفروقات والأدوات المالية ذات الصلة. كما نلتزم بالامتثال لقوانين مكافحة غسيل الأموال وتمويل الإرهاب. لذا، نرجو تقديم معلومات دقيقة وشاملة وحقيقية كما هو مطلوب، لكي نتمكن من استكمال الامتثال إلى القوانين المذكورة أعلاه. بالاستناد إلى هذه المعلومات، يمكننا تحديد ما إذا كانت الخدمات الاستثمارية المتعلقة بالأدوات المالية مناسبة لك أم لا. يجب استكمال جميع الخانات المطلوبة. للمزيد من التفاصيل، يرجى الرجوع إلى اتفاقية العميل الخاصة بنا. ',
		byTicking: 'أوافق على بيان إخلاء المسئولية أعلاه.',
		getstarted: 'استمرار',
		messageFooter1: 'الخدمات والمنتجات المقدمة من قبل',
		messageFooter2:
			'الخدمات والمنتجات المقدمة من قبلنا لا تتوفر داخل الولايات المتحدة (US) ولا تُقدَّم للأشخاص الأمريكيين، كما هو محدد بموجب القانون الأمريكي. المعلومات الموجودة على هذا الموقع ليست موجهة للمقيمين في أي بلد حيث يكون تداول الفوركس و/أو عقود الفروقات (CFDs) مقيدًا أو محظورًا بموجب القوانين أو اللوائح المحلية. عقود الفروقات هي أدوات مالية معقدة وتحمل خطرًا عاليًا بفقدان المال بسرعة بسبب الرافعة المالية. بين 74% و89% من حسابات المستثمرين الأفراد يخسرون المال عند تداول عقود الفروقات. يجب عليك أن تعتبر ما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كنت تستطيع تحمل المخاطر العالية لفقدان أموالك. 74-89% من حسابات عقود الفروقات للأفراد تخسر المال. لمزيد من المعلومات حول رسومنا، يرجى الرجوع إلى هذا الرابط.',
		client: 'خزانة العميل',
		instructionstitle1: 'جميع أدوات التحكم',
		instructionstitle2: 'في حساباتك في',
		instructionstitle3: 'متناول يديك',
		options1f: ' الإيداع الفوري',
		options1l: ' في الحساب ',
		options2f: 'التحويل ما بين ',
		options2l: 'الحسابات',
		options3f: 'السحب السريع',
		options3l: '',
		haveAccount: 'هل لديك حساب بالفعل؟',
		signUp: ' تسجيل الدخول',
		newCode: 'تم إرسال رمز لمرة واحدة فقط إلى',
		tryEgain: 'لا يمكننا إعادة إرسال الرمز الخاص بك الآن. حاول مرة أخرى.',
		invalidEmail: 'تنسيق غير صالح! برجاء المحاولة مرة أخرى.',
		passwordRequired: 'هذه الخانة مطلوبة',
		invalidPassword:
			'يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف إنجليزية على الأقل تتضمن حرفًا صغيرًا، حرفًا كبيرًا، رقمًا، و رمزا واحدًا على الأقل.  مثال على الرمز  !@#$%^&*',
		confirmPasswordRequired: 'هذه الخانة مطلوبة',
		passwordsDoNotMatch:
			'كلمات المرور التي قمت بإدخالها غير متطابقة. برجاء التحقق وإعادة المحاولة مرة أخرى.',
		errorDisclaimer:
			'برجاء الضغط على المربع الخاص بإقرار اخلاء المسئولية للمتابعة.',
		firstNameError: 'هذه الخانة مطلوبة',
		typeAccountError: 'يرجى اختيار نوع الحساب',
		invalidName:
			'يجب ألا يحتوي اسمك الأول على أي أرقام أو رموز. برجاء المحاولة مرة أخرى.',
		invalidLastName:
			'لا يمكن أن يحتوي اسم العائلة على أرقام أو رموز. يرجى المحاولة مرة أخرى.',
		mfaCode: 'أدخل رمز المصادقة متعددة العوامل (MFA)',
		startDemo: 'افتح حسابك التجريبي المجاني الآن!',
		orRegister: 'أو سجل من هنا:',
		verificationCode: 'رمز التفعيل',
		didntCode: 'لم تتلق أي رمز؟',
		yourEmail: 'بريدك الإلكتروني',
		firstName: 'الاسم الأول',
		lastName: 'الاسم الأخير',
		accountType: 'نوع الحساب',
		accountCategory: 'نوع الحساب:',
		accountCategoryPlaceholder: 'اختر نوع الحساب',
		accountCategoryTooltip: `<strong>الحساب الفردي:</strong>  </br>  اختر هذا النوع إذا كنت تريد التداول بمفردك. </br></br> <strong>الحساب المشترك:</strong>  </br> اختر هذا النوع إن كنت تريد التداول بالمشاركة مع شخص أخر، مثل الزوج أو صديق. </br></br> <strong>حساب الشركات:</strong> </br>  اختر هذا النوع، إن كنت تمثل شركة أو مؤسسة أو منظمة. `,
		entity: 'الكيان::',
		entityPLaceholder: 'حدد كيانًا',
		entityTooltip:
			'نلتزم بقوانين مالية صارمة في كل الدول التي نعمل بها. اعرف أكثر من هنا.',
		countryTooltip:
			'إذا لم يكن بلد إقامتك مدرجًا في الخيارات، نأسف لإبلاغك أننا غير قادرين على تقديم خدماتنا في موقعك.',
		checkRegis:
			'بتحديد هذا المربع، أقر بأنني لم أتلقى أي دعوة من Tradeview أو أي فرد مرتبط بـ Tradeview لتغيير الكيانات.',
		changeRegion: 'تغيير إلى كيان منطقتي',
		liveIndividual: 'حساب فردي حقيقي </br> ابدأ التداول الآن!',
		jointIndividual: 'حساب مشترك حقيقي </br> ابدأ التداول الآن!',
		corporateIndividual: 'حساب شركة حقيقي </br> ابدأ التداول الآن!',
		entityText:
			'أنت على وشك اختيار كيان لإنشاء حسابك في منطقة مختلفة عن دولتك المقيمة المختارة.',
		entity: 'الكيان:',
		entityPLaceholder: 'حدد كيانًا',
		entityTooltip:
			'نلتزم بقوانين مالية صارمة في كل الدول التي نعمل بها. اعرف أكثر من هنا.',
		accountRegis: 'التسجيل في حساب تجريبي مجاني',
		entityTextEu: `الموقع الذي تقوم بزيارته تديره كيان غير مسجل في الاتحاد الأوروبي أو منظم من قبل سلطة مختصة في الاتحاد الأوروبي. <br><br>  بالنقر على 'استمرار'، فإنك تؤكد أنك لم تتلقى أي دعوة من Tradeview أو أي فرد مرتبط بـ Tradeview لتغيير الكيانات. <br><br> للانتقال إلى الكيان المنظم في الاتحاد الأوروبي، Tradeview Europe Ltd.، يرجى النقر على 'تغيير إلى كيان منطقتي'. Tradeview Europe Ltd. منظم من قبل MFSA، وهو مناسب لولايتك القضائية.`,
		entitiesTitle: 'الكيانات الدولية التي تتداول تحت علامتنا التجارية:',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> 
		<p>منظمة من قبل هيئة النقد في جزر كايمان (CIMA) وتعمل تحت قوانين جزر كايمان (SIBL).</p>
		<br> <ul> <li> <b>Tradeview Financial Markets S.A.C (بيرو، اليابان، MENA)</b> </li> </ul> 
		<p>مسجلة في SUNARP، وتعمل تحت القانون العام للشركات (LGS) في بيرو.</p> <br> 
		<ul> <li> <b>Tradeview Europe Ltd.</b> </li> </ul> <
		p>منظمة من قبل هيئة الخدمات المالية في مالطا (MFSA)، عضو في EBA، ESMA و IOSCO.</>`,
		entitiesDescEu: `<ul> <li><b>تريدفيو المحدودة (CIMA)</b></li> </ul> <p>مرخصة من قبل هيئة النقد لجزر كايمان (CIMA) وتعمل وفقًا لقوانين جزر كايمان (SIBL)</p> <br> <ul> <li><b>تريدفيو للأسواق المالية S.A.C (بيرو، اليابان، MENA)</b></li> </ul> <p>مسجلة في SUNARP وتعمل بموجب القانون العام للشركات (LGS) في بيرو.</p> <br> <ul> <li><b>تي في إم جلوبال المحدودة</b></li> </ul> <p>مرخصة من قبل هيئة الخدمات المالية في لابوان (FSA) وتعمل بموجب قوانين لابوان.</p> `,
		individual: 'فردي',
		joint: 'مشترك',
		corporate: 'شركة كبرى',
		individualIB: 'حساب الوسيط المعرف الفردي',
		reloadPage:
			'يرجى تحديث الصفحة للمتابعة. سيؤدي ذلك إلى إصلاح مشكلة تمنع إدخال البيانات.',
		instructionsIB1: 'قم بتنمية أعمال الوساطة الخاصة بك ',
		instructionsIB2: 'أعمالك - كن وسيطاً معرفاً ',
		instructionsIB3: 'في أقل من 5 دقائق!',
		titleIbRegister: 'جديد في Tradeview ؟ ',
		disclaimerIBportal:
			'إخلاء المسؤولية: قبل فتح الحساب، من واجبنا في شركة Tradeview Financial Markets S.A.C. (Tradeview) التأكد من أنك أو الشخص/الأشخاص المعينين للتداول نيابة عنك لديهم المعرفة والخبرة اللازمة في عقود الفروقات والأدوات المالية ذات الصلة. ومن متطلباتنا أيضًا الامتثال لالتزامات مكافحة غسل الأموال وتمويل الإرهاب. وفي هذا الصدد، يُرجى منكم التكرم بتقديم معلومات دقيقة وكاملة وواقعية على النحو المطلوب بما يتماشى مع هذا الطلب ولكي نتمكن من استكمال الامتثال للالتزامات المذكورة أعلاه. وبناءً على هذه المعلومات يمكننا تحديد ما إذا كانت خدمات الاستثمار المتعلقة بالأداة/الأدوات المالية مناسبة لك أم لا. يجب استكمال جميع الأقسام. لمزيد من التفاصيل يرجى الرجوع إلى اتفاقية العميل الخاصة بنا.',
		alreadyClient:
			'هل أنت عميل لدى Tradeview؟ قم بتسجيل الدخول إلى لوحة التحكم الخاصة بك للتسجيل كوسيط معرف (IB).',
		loginClientCabinet: '',
		registerIB: '',
		instructionsIBportal1: 'لقد قمنا بتغطيتك! حلول لكل احتياجاتك',
		instructionsIBportal2: '',
		instructionsIBportal3: '',
		options1f_ib_portal: 'الحلول المتكاملة',
		options1l_ib_portal: '',
		options2f_ib_portal: 'دعم العملاء',
		options2l_ib_portal: 'متاح 24/5',
		options3f_ib_portal: 'المدفوعات اليومية للخصومات والعمولات',
		options3l_ib_portal: '',
		register_enjoy: 'سجل الآن واستمتع بـ:',
		fast_onboarding: 'عملية تسجيل سريعة',
		no_program: 'برنامج بدون تكاليف مسبقة',
		fast_solutions: 'حلول متكاملة لعملائك',
	},

	'reset-password': {
		instructionstitle1: 'جميع أدوات التحكم',
		instructionstitle2: 'في حساباتك في',
		instructionstitle3: 'متناول يديك',
		title: 'اضبط كلمة مرور جديدة',
		label1: 'كلمة المرور الجديدة',
		label2: 'تأكيد كلمة المرور',
		options1f: ' الإيداع الفوري',
		options1l: ' في الحساب',
		options2f: 'التحويل ما بين',
		options2l: 'الحسابات',
		options3f: 'السحب السريع',
		options3l: '',
	},

	//Calendar
	calendar: {
		title: 'تقويم',
	},

	//application process
	application: {
		optional: '(オプション)',
		ifApplicable: '(إن أمكن)',
		jobTitleL: 'المسمى الوظيفي',
		jobTitleP: 'أدخل المسمى الوظيفي الخاص بك',
		emplymentAditionalDetails: 'معلومات إضافية',
		optional: ' (اختياري)',
		taxResTitle: 'إقرار الإقامة الضريبية الخاص بك',
		taxResPurposes: 'هل أنت أمريكي أو تقيم في الولايات المتحدة الأمريكية؟',
		taxLabelCompany:
			'تؤكد الشركة بموجب هذا أنها، لأغراض ضريبية، مقيمة في البلد التالي:',
		taxLabelIndividual:
			'أقر بموجب هذا أنني، لأغراض ضريبية، مقيم في البلد التالي:',
		taxResHereby: 'لأغراض ضريبية، أؤكد أنني مقيم في البلد التالي:',
		taxResCountryL: 'الدولة',
		taxResCountryP: 'اختر دولة',
		taxResMarketL: 'رمز الضريبة المرجعي ',
		jobTitleL: ' عنوان الوظيفة',
		jobTitleP: ' ادخل عنوانك الوظيفي',
		taxResMarketP: 'ادخل كودك الضريبي',
		taxResMarketTM:
			"يتكون الكود الضريبي من مزيج من الأرقام والحروف، وقد يتكون من الأرقام فقط. لا تقلق، معلوماتك معنا في أمان، حيث أننا نلتزم بقوانين صارمة في هذا الأمر. <a href='https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/' target='_blank'> اعرف أكثر من هنا.</a>",
		taxResPoliticalL:
			'هل تعمل في السياسة؟ أو أنك قريب أو زميل لشخص سياسي معروف؟ ',
		taxResPoliticalTM:
			'الشخصية السياسية، هو ذلك الشخص الذي يشغل منصبًا عامًا بارزًا في أي دولة، ولديه تأثير محتمل على السياسات وتقييم المخاطر المالية. ',
		taxResStatusL: 'هل أنت شخصية سياسية؟ أو لديك علاقة بسياسي؟',
		taxResStatusP:
			'برجاء إخبارنا بتفاصيل حول عملك السياسي أو علاقتك بشخص سياسي إن وجدت.',
		taxResStatusTM:
			'يجب عليك الكشف عن عملك السياسي، أو أي اتصال أو قرابة مع شخصية سياسية. ومع ذلك، اطمئن، فحتى إن كنت واحد من الشخصيات السياسية أو لديك علاقات بأحد السياسيين، فمازال بإمكانك تقديم الطلب. ',
		taxCode: 'رمز المرجع الضريبي',
		taxCodeTooltip: `قد يتكون رمز المرجع الضريبي الخاص بك من مزيج من الأحرف والأرقام، أو قد يكون رقميًا بالكامل. معلوماتك آمنة معنا. نحن مطالبون بجمع هذه المعلومات وفقًا لمعايير الإبلاغ الخاصة بمنظمة التعاون الاقتصادي والتنمية (OECD). يمكنك معرفة المزيد عنها <a href="https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/" target="_blank" rel="noopener noreferrer">هنا.</a>.`,
		selectTaxCode: 'أدخل رمز المرجع الضريبي الخاص بك',
		accountTypeH: 'نوع الحساب',
		accountTypeD:
			'بعد إنشاء حسابك الأول مع  Tradeview، بإمكانك فتح المزيد من الحسابات لأصول مختلفة دون الحاجة إلى إعادة ملء النموذج بالكامل مرة أخرى.',
		tradingMarketL: 'سوق التداول',
		tradingMarketP: 'اختر سوق',
		tradingMarketTM:
			"سوق التداول هو السوق أو البورصة التي يتم فيها إدراج أصل أو أداة مالية معينة وطرحها للتداول.<br><br> لا تعرف أي سوق تختار؟ استعرض الأسواق من <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>هنا. </a>",
		currencyTypeL: 'نوع العملة',
		currencyTypeP: 'يرجى اختيار أحد الخيارات',
		currencyTypeTM: 'العملة هي طريقة الدفع التي ستتعامل بها في حسابك.',
		platformL: 'المنصة',
		platformP: 'اختر منصة',
		platformTM:
			"منصة التداول هي عبارة عن نظام برمجي يتم من خلاله فتح المراكز وإغلاقها. <br><br>لا تعرف أي منصة تختار؟ استعرض المنصات من<a href='https://www.tvmarkets.com/trading/platforms' target='_blank'> هنا.</a>",
		accountTypeL: 'نوع الحساب',
		accountTypeP: 'اختر نوع الحساب',
		accountTypeTM:
			"يتيح لك نوع الحساب تحديد شروط التداول مثل الرافعة المالية، فروق الأسعار والعمولات في حسابك. <br><br>  يمكنك استعراض الشروط الخاصة بكل نوع حساب من   <a href='https://www.tvmarkets.com/trading/accounts' target='_blank'>  هنا. </a>",
		emplymentDetailsH: 'معلوماتك الوظيفية',
		employmentStatusL: 'الحاله الوظيفيه الحاليه',
		employmentStatusP: 'اختر حاله',
		employerL: 'صاحب العمل',
		employerP: 'ادخل عملك',
		occupationL: 'مهنتك',
		occupationP: 'ادخل مهنتك',
		industryL: 'المجال',
		industryP: 'اختر مجال عملك',
		industryTM:
			'يمثل مجال العمل الخصائص والأنشطة التي تقوم بها الشركة التي تعمل فيها. ',
		employmentTypeL: 'نوع الوظيفة',
		employmentTypeP: 'اختر نوع وظيفتك',
		employmentTypeTM:
			'يمثل نوع الوظيفة الخصائص والقواعد التي تنظم طبيعة عملك ونوعك الوظيفي',
		employmentAddressL: 'عنوان الوظيفة',
		employmentAddressP: 'ادخل عنوانك الوظيفي',
		employerCountryL: 'الدولة التي تعمل بها',
		employerCountryP: 'اختر دولة',
		employerProvinceL: 'الولاية التي تعمل بها',
		employerProvinceP: 'اختر ولاية',
		employerCityL: 'المدينة التي تعمل بها',
		employerCityP: 'اختر مدينة',
		employerZipL: 'الرمز البريدي لعنوانك الوظيفي',
		employerZipP: 'ادخل الرمز البريدي لعنوانك الوظيفي',
		businessTypeL: 'نوع العمل',
		businessTypeP: 'اختر نوع العمل',
		businessTypeTM:
			'يمثل نوع العمل الهيكل الوظيفي والإطار القانوني الذي تعمل ضمنه المؤسسة.',
		businessCountryL: 'دولة العمل',
		businessCountryP: 'اختر دولة',
		businessProvinceL: 'مقاطعة العمل',
		businessProvinceP: 'اختر ولاية',
		businessCityL: 'مدينة العملة',
		businessCityP: 'اختر مدينة',
		businessLocationL: 'عنوان العمل',
		businessLocationP: 'ادخل عنوان العمل',
		businessNameL: 'اسم العمل',
		businessNameP: 'ادخل اسم عملك',
		businessWebL: 'الموقع الإلكتروني للعمل',
		businessWebP: 'ادخل رابط موقعك الإلكتروني',
		businessIndustryL: 'المجال',
		businessIndustryP: 'اختر مجال عملك',
		businessIndustryTM:
			'يمثل مجال العمل الخصائص والأنشطة التي تقوم بها الشركة التي تعمل فيها. ',
		financialDetailsH: 'معلوماتك المالية',
		annualIncomeL: 'ما هو دخلك السنوي؟',
		totalAssetsL: 'ما هو إجمالي مبلغ الأصول التي تمتلكها؟',
		totalAssetsTM:
			'الأصول هي المدخرات والعقارات والاستثمارات الأخرى التي تمتلكها بعد خصم التزاماتك.',
		liquidAssetsL: 'ما هو مستوى السيولة لديك؟',
		liquidAssetsTM:
			'الأصول السائلة، هي الأموال النقدية التي تمتلكها بعيدًا عن الأصول المجمدة.',
		tradeAnnuallyL: 'ما هو المبلغ الذي تنوي استثماره أو تداوله سنويًا؟',
		originAssetsL: 'ما هو المصدر الذي حصلت من خلاله على أصولك؟',
		originDepositsL: 'ما هو المصدر الذي حصلت من خلاله على أموالك؟',
		purposeAccountL: 'ما هو الغرض من فتح حساب تداول؟',
		bankruptciesDetailsL: 'تفاصيل الإفلاس',
		bankruptciesDetailsP: 'إضافة معلومات عن احتمالات الإفلاس',
		bankruptciesDetailsTM:
			'يجب أن تكشف عن أي صلة لك بأي عمليات إفلاس محتملة، وذلك من أجل تقييم المخاطر لكلا الطرفين (أنت و Tradeview) <br><br> ومع ذلك، اطمئن فحتى إذا كان هناك فرص لإفلاس محتمل، فمازال مرحبًا بك في مواصلة تقديم طلب فتح الحساب.',
		bankruptciesConnetL: 'هل هناك احتمالات لإعلان إفلاسك؟',
		tradingExperienceH: 'خبرتك في التداول',
		tradingExperienceD:
			'اختر الخيار الذي يمثل تجربتك في تداول الفوركس أو الأسهم أو المشتقات أو عقود الفروقات بأفضل شكل',
		tradingExperienceDMENA:
			'اختر الخيار الذي يُعبر بشكل أفضل عن تجربتك في تداول الفوركس، الأسهم، المشتقات أو عقود الفروقات (CFDs).',
		tradingExperienceTM:
			'نريد أن نعرف أكثر عن تجربتك وخبرتك في التداول لمساعدتنا في تقديم دعم أكثر ملائمة لك سواء كنت متداول مبتدئ أو محترف. ',
		yearsTradingL: 'كم عدد السنوات التي تداولت فيها؟',
		yearsTradingP: 'يرجى اختيار أحد الخيارات',
		tradingVolumenL: 'ما هو حجم تداولاتك؟',
		tradingVolumenP: 'يرجى اختيار أحد الخيارات',
		oftenTradeL: 'كم مرة تتداول عادة؟',
		oftenTradeP: 'يرجى اختيار أحد الخيارات',
		identityH: 'التحقق من هويتك',
		identityDesc: 'ستحتاج إلى إحدى الوثائق التالية لإجراء عملية التحقق:',
		identityD:
			'للتحقق من هويتك، سنقوم بإعادة توجيهك إلى رابط خارجي. هذه الخطوة إلزامية، ونوصي بإكمالها على جهازك المحمول باستخدام رمز الاستجابة السريعة (QR) أدناه لتجربة أكثر سلاسة.',
		identityDLatam:
			'للحصول على تجربة أكثر سلاسة، نوصي بإكمال هذه الخطوة على هاتفك باستخدام رمز الاستجابة السريعة أدناه.ستحتاج إلى إحدى الوثائق التالية لإجراء عملية التحقق:',
		idDocumentL: 'اختر نوع المستند',
		idDocumentP: 'اختر نوع المستند',
		idDocumentTM:
			'يمثل نوع المستند أي وثيقة حكومية يمكن استخدامها لتأكيد هويتك. يمكنك الاختيار بين التالي: <br> <br> جواز السفر <br> البطاقة الشخصية<br> تصريح الإقامة<br> رخصة القيادة',
		idDocumentUploadL: 'تحميل المستند',
		idDocumentUploadTM:
			'يرجى التأكد من أن المعلومات والصور الواردة في الملف واضحة ومفهومة.',
		idDocumentFrontL: 'الوجه الأمامي للوثيقة',
		idDocumentFrontTM: 'قم بأخذ صوره من وجه الوثيقة.',
		idDocumentBackL: 'الوجه الخلفي للوثيقة',
		idDocumentBackTM: 'قم بأخذ صوره من خلفيه الوثيقة.',
		proofResidenceH: 'إثبات محل الإقامة',
		proofResidenceHYour: 'إثبات محل إقامتك',
		proofResidenceD: 'رجاء تقديم اثبات السكن لإتمام اجراءات فتح الحساب.',
		proofResidenceL: 'مستند إثبات محل الإقامة',
		proofResidenceP: 'اختر نوع المستند',
		proofResidenceTM:
			'لإثبات عنوانك ومحل إقامتك، برجاء تقديم واحد من المستندات التالية: <br> نقبل المستندات التالية: <br><br>  •  فاتورة مرافق<br>  • كشف حساب بنكى <br> •  شهادة الإقامة     <br><br>   نقبل الفواتير التالية:   <br>• غاز    <br>•   كهرباء  <br>  • مياه  <br>  •    الهاتف الأرضي  <br>  •  الإنترنت (إذا كان متصلًا بالسكن)  <br>  •  الكابل (إذا كان متصلاً بالسكن)  <br> •  كشف حساب البنك أو البطاقة الائتمانية (مع سجل المعاملات)<br> <br> لا نقبل فواتير الهاتف المحمول أو البيانات البنكية التي تظهر إيداعات نقدية كبيرة. ',
		proofUploadL: 'تحميل المستند ',
		proofUploadTM:
			'برجاء التأكد من أن المستند: <br><br> • صادر من 3 أشهر كحد أقصى. <br>• يتضمن اسمك. <br>• العنوان الموجود فيه يتطابق مع العنوان الذي سجلته لدينا. <br>• ليس لطقة شاشة. <br>• غير مقطوع. <br>• لا يحتوي على معلومات محظورة أو مخفية. <br>• مكتوب بلغة يمكن ترجمتها.',
		addressDetail: 'العنوان',
		financialDetailsTM:
			'يجب عليك الكشف عن معلوماتك المالية من أجل تقييم المخاطر بشكل صحيح لكلا الطرفين (أنت وTradeview).',
		acknowledgementH: ' الإقرار',
		acknowledgementCheck:
			'أقر و أوافق بأنني قرأت المستندات المذكورة أعلاه وفهمت المعلومات المقدمة فيها بشكل كامل.',
		signatureH: 'التوقيع',
		signatureP1:
			'بالتوقيع أدناه، أقر وأوافق على صحة المستندات المقدمة في الخطوة السابقة. ',
		signatureP2:
			'كما أقر وأوافق أيضًا، أن جميع المعلومات التي قمت بتقديمها في طلب التسجيل دقيقة وصحيحة، وأن الأموال التي سأقوم بإيداعها في حسابي، بغض النظر عن مصدرها أو طريقة إيداعها نوع عملتها، حصلت عليها من مصادر مشروعة وأنها بعيدة كل البعد عن أي أنشطة غير قانونية أو إجرامية. ',
		signatureMethod: 'ما هي الطريقة التي تفضها للتوقيع؟ ',
		signatureDraw: 'التوقيع يدويًا',
		signatureUpload: 'تحميل التوقيع',
		signatureTM:
			'اختر الطريقة التي تقدم بها توقيعك. يكمنك التوقيع يدويًا بشكل مباشر من خلال أداة تفاعلية خاصة، أو يمكنك تحميل توقيعك. اختر من بين:',
		signatureAD: 'توقيع العميل المعتمد, قم بالتوقيع أعلاه.',
		additionalRiskH: 'الكشف عن المخاطر الإضافية',
		additionalRiskD1:
			'إن المعلومات المقدمة في طلب فتح حساب لا تستوفي معايير .Tradeview Financial Markets S.A.C الخاصة بفتح حساب تداول، لواحد أو أكثر من الأسباب التالي: ',
		additionalRiskP1Latam:
			'بالإضافة إلى الإفصاحات القياسية في الصناعة التي يتضمنها اتفاقية حساب العملاء من Tradeview Markets، يجب أن تكون على دراية بأن تداول الفوركس يعتبر شكلاً محفوفاً بالمخاطر من الاستثمار. إذا كنت قد اتبعت فقط أشكالاً محافظة من الاستثمار في الماضي، فقد ترغب في دراسة تداول الفوركس بشكل أعمق قبل الاستمرار في استثمار من هذا النوع.',
		additionalRiskP2Latam:
			'إذا كنت ترغب في الاستمرار في استثمارك، فإنك تقر بأن الأموال التي قمت بتخصيصها هي رأس مال مخاطرة بحتة وأن خسارة استثمارك لن تعرض أسلوب حياتك للخطر ولا ستؤثر على برنامج تقاعدك المستقبلي. بالإضافة إلى ذلك، أنت تفهم تمامًا طبيعة ومخاطر استثمارات الفوركس، ولن يتم إهمال التزاماتك تجاه الآخرين في حال تعرضت لخسائر استثمارية.',
		additionalRiskUl1: 'لا يتراوح عمرك بين 21 و63 عامًا. ',
		additionalRiskUl2: 'دخلك السنوي أقل من 25000 دولار أمريكي.',
		additionalRiskUl3: 'كنت معرض للإفلاس خلال العام الماضي.',
		additionalRiskUl4: 'لا تعمل.',
		additionalRiskD2:
			'بينما يمكن لـ - .Tradeview Financial Markets S.A.C فتح حساب تداول لك، إلا أنها تنصحك بإعادة النظر مرة أخرى في أمر التداول. فبناء على معلوماتك الشخصية وخبرتك، قد يكون تداول الفوركس غير مناسبة لك ومحفوفًا بالمخاطر. يمكن أن تخسر الكثير من الأموال في تداول العملات الأجنبية. لذا، يجب عليك إعادة التفكير في إن كان التداول مناسبًا لك ولظروفك المالية أم لا. استخدام الرافعة المالية العالية في تداول العملات الأجنبية بسبب متطلبات الهامش، يمكن أن يكون ضدك بنفس القدر الذي تعمل فيه لصالحك، فاستخدام الرافعة المالية قد يضاعف خسائرك مثلما قد يضاعف أرباحك.',
		additionalRiskChk1:
			'أتفهم أنني لا أستوفي الحد الأدنى من معايير فتح الحساب التي حددتها Tradeview Ltd بالأعلى. ومع ذلك، أنا على وعي بالمخاطر المالية التي يحتوي عليها تداول الفوركس، وأرغب في مواصلة فتح الحساب أيًا كان.',
		additionalRiskChk2:
			'أقر بأنني قد قرأت كل ما ورد بالأعلى، وأنني أفهم جيدًا المعلومات المقدمة هنا.',
		additionalRiskChk1Latam:
			'أقر انني على علم بالمخاطر المتعلقة بالتداول في أسواق المال العالمية و أنا مستعد لمتابعة عملية فتح الحساب.',
		additionalRiskChk2Latam:
			'أقر بأنني قد قرأت كل ما ورد بالأعلى، وأنني أفهم جيدًا المعلومات المقدمة هنا. ',
		submitApplicationH: ' إرسال الطلب',
		submitApplicationD1:
			'لقد قاربت على الانتهاء! نقدر وقتك ومجهودك في إكمال الطلب. ',
		submitApplicationD2: 'اضغط على زر الإرسال الموجود بالأسفل لتقديم الطلب.',
		submitApplicationD3:
			'إذا كان لديك أي أسئلة أو كنت بحاجة إلى المساعدة، فلا تتردد في ذلك',
		submitApplicationLink: 'اتصل بنا',
		submitApplicationCheck:
			'أوافق على أن أكون جزءًا من القائمة التسويقية الخاصة بكم.',
		applicationSubmitedH: 'تم تقديم طلبك بنجاح! جاري مراجعة طلبك',
		applicationSubmitedD1:
			'نشكرك على تقديم طلبك لفتح حساب معنا. طلبك الآن قيد المراجعة و سيتم التحقق منه قريباً.',
		applicationSubmitedD2:
			'  سيقوم أحد ممثلي فريق الدعم العربي بالتواصل معك إن كنت لا تزال بحاجة إلى تقديم بعض المستندات الإضافية. نشكركم مرة أخرى لاختياركم لشركة تريدفيو.',
		applicationSubmitedD3: ' ',
		applicationSubmitedGT: 'الذهاب إلى منطقه العملاء',
		applicationSubmitedET: 'تعرف على Tradeview',
		apEmailL: 'البريد الإلكتروني',
		apFirstNL: 'الاسم الأول',
		apFirstNP: 'الاسم الأول',
		apLastNL: 'الاسم الأخير',
		apLastNP: 'الاسم الأخير',
		apDateBL: 'تاريخ الميلاد',
		apCountryBL: 'محل الميلاد',
		apCountryBP: 'اختر دولة',
		apCountryNL: 'الجنسية',
		apCountryNP: 'اختر جنسية',
		apMobileL: 'رقم الهاتف المحمول (اختياري)',
		apMobileLReq: 'هاتف جوال',
		apPhoneL: 'الهاتف ',
		apPassL: 'رقم جواز السفرأو الهوية الوطنية',
		apPassP: 'رجاء ادخال رقم الهوية أو جواز السفر الخاص بك',
		apPassT:
			'تحتاج فقط إلى تقديم وثيقة تعريف واحدة. يرجى ملاحظة أن رقم التأمين الاجتماعي (SIN) مطلوب فقط للمستخدمين في كندا',
		apPassDL: 'تاريخ الانتهاء الخاص بالهوية',
		apGenderL: 'الجنس',
		apGenderP: 'يرجى اختيار أحد الخيارات',
		apMaritalL: 'الحالة الاجتماعية',
		apMaritalP: 'يرجى اختيار أحد الخيارات',
		apCountryRL: 'الدولة محل الإقامة',
		apCountry: 'الدولة',
		apCountryRLTooltip: `يشير هذا إلى الدولة التي يقع فيها عملك بشكل أساسي. تساعدنا المعلومات الدقيقة على تخصيص خدماتنا وفقًا للمتطلبات واللوائح الإقليمية. إذا لم تكن دولتك مدرجة في الخيارات، نأسف لإبلاغك بأننا غير قادرين على تقديم خدماتنا في موقعك.`,
		apCountryRLResidence: 'بلد الإقامة',
		apCountryRP: 'اختر دولة',
		apProvinceRL: 'الولاية/ المقاطعة',
		apProvinceRP: 'اختر ولاية',
		apCityRL: 'المدينة',
		apCityRP: 'اختر مدينة',
		apStreethRL: 'عنوان الاقامة',
		apStreethRD: 'ادخل عنوان الاقامة الخاص بك',
		apStreethNL: 'رقم الشارع',
		apStreethND: 'ادخل رقم الشارع الخاص بك',
		apPostCL: 'الرمز البريدي',
		apPostCD: 'ادخل الرمز البريدي الخاص بك',
		appAddresT:
			'إن لم تكن الدولة محل إقامتك موجودة ضمن قائمتنا، فيؤسفنا إبلاغك أننا غير قادرين على تقديمك خدماتنا في دولتك.',
		modalRegulationT: 'لا يمكن الاستمرار في تقديم طلبك',
		modalRegulationT2: '',
		modalCompleteP:
			'لدينا جميع المعلومات اللازمة لإتمام العملية. الخطوة الأخيرة هي إضافة توقيع صاحب الحساب وتقديم الطلب. رحلتك على وشك الانتهاء!',
		modalRegulationT: 'لا يمكن الاستمرار في تقديم طلبك',
		modalRegulationT2: '',
		modalRegulationP:
			'يؤسفنا ان نخبرك انه غير متاح قبول طلبك في الوقت الحالي نظرا لانك مقيم في الولايات المتحدة الامريكية. اذا كان لديك اي استفسار اخر تفضل بالتواصل معنا عبر الايميل التالي: ar@tvmarkets.com.',
		modalRegulationP2: '',
		signatureTM2:
			'تأكد من أن التوقيع المقدم يتطابق مع التوقيع الذي أرفقته سابقًا. تأكد من أن صيغة الملف JPEG أو PNG أو PDF وأن حجمه لا يتجاوز 3 ميجابايت.',
		submitModal:
			'يبدو أن هناك بعض الأخطاء في نموذج التسجيل، برجاء مراجعة المعلومات المدخلة مرة أخرى والتأكد منها. في حالة استمرار المشكلة، يرجى التواصل معنا.',
		areaPH: 'رمز المنطقة',
		phonePH: 'أدخل بقية الرقم',
		emailPH: 'ادخل بريدك الإلكتروني',
		errorUpload: 'برجاء تحميل ملف بصيغة وحجم مناسبين.',
		apBtnContinue: 'استمرار',
		apBtnSubmit: 'استمرار',
		apBtnBack: 'العودة إلى الخلف',
		apBtnRegulation: 'زيارة صفحة التنظيم والترخيص',
		complete: 'مكتمل',
		pending: 'قيد الانتظار',
		rejected: 'مرفوض',
		accepted: 'قبلت',
		enterFirstName: 'ادخل الاسم الأول',
		enterLastName: 'ادخل الاسم الأخير',
		enterAnEmail: 'ادخل البريد الإلكتروني',
		sendInvitation: 'إرسال الدعوات',

		invitationSent: 'تم إرسال الدعوة بنجاح!',
		invitationSentDesc: 'يمكنك متابعة تقدم الطلب في صفحة إضافة الحامل الثانوي.',
		modifiedInvitation: 'تم تحديث معلومات حامل الحساب الثانوي بنجاح',
		modifiedInvitationDesc:
			'تم إرسال دعوة إلى عنوان البريد الإلكتروني الذي قدمته لحامل الحساب الثانوي. يمكنك متابعة تقدم الطلب في صفحة إضافة الحامل الثانوي.',
		notModifiedInvitation: 'تم تحديث معلومات حامل الحساب الثانوي بنجاح',
		notModifiedInvitationDesc:
			'يمكنك متابعة تقدم الطلب في صفحة إضافة الحامل الثانوي.',
		resend: 'إعادة إرسال الدعوة',
		saveShareholder: 'حفظ المساهم',
		shareholderToComplete: 'دعوة المساهم لإكمال',
		companyDocuments: 'التحقق من وثائق الشركة',
		companyDocumentsDesc:
			'أكد حسابك، واضمن الحصول على خدمات تناسب احتياجات عملك.',
		documentUpload: 'تحميل المستند',
		documentUploadTooltip1:
			'"تأكد من أن المعلومات والصور الموجودة في الملف واضحة ومفهومة.',
		documentUploadTooltip2:
			'لا تتردد في تحميل المستندات التي لديك في الوقت الراهن. لا تقلق إذا كان البعض مفقودًا؛ يمكنك تحميلها أو إرسالها لاحقًا عند الطلب.',
		documentUploadDesc:
			'هل تريد تحميل المستندات الآن؟ أم حفظها لوقت لاحق؟ في حالة اختيار التحميل الآن، يمكنك سحب الوثائق وإسقطاها بسهولة، أو رفعها من جهازك. ',
		articlesIncorp: 'عقود تأسيس الشركة',
		certificateIncorp: 'وثيقة تأسيس الشركة',
		shareholderBreak: 'المشاركين في الشركة',
		corporateBank: 'كشف حساب البنك الخاص بالشركة',
		memorandumArticles: 'عقد التأسيس',
		uploadNow: 'تحميل الآن',
		imageType:
			'تأكد من أن صيغة الملف JPEG أو PNG أو PDF وأن حجمه لا يتجاوز 3 ميجابايت.',
		sharesError:
			'لا يجب أن تتجاوز حصص المساهمين وصاحب الحساب 100%. برجاء المحاولة مرة أخرى.',
		inviteConfirmation: 'مستعد لإرسال الدعوات إلى المساهمين؟ ',
		inviteConfirmationDesc:
			'سيتم إرسال بريد واحد إلى جميع المساهمين الذين تريد إضافتهم إلى حسابك. بمجرد إرسال الدعوات، لن تتمكن من إضافة المزيد من المساهمين. ',
		inviteSent: 'تم إرسال الدعوات بنجاح!',
		inviteSentDesc: 'يمكنك متابعة تقدم الطلب لكل مساهم في صفحة إضافية.',
		deleteHolder: 'متأكد أنك تريد حذف هذا المساهم؟',
		deleteHolderDesc:
			'أنت على وشك إزالة أحد المساهمين من حساب شركتك. هل تريد الاستمرار؟ ',
		unableToContinue: 'غير قادر على الاستمرار',
		unableToContinueDesc:
			'عنوان البريد الإلكتروني الذي قدمته مرتبط بالفعل بحساب في Tradeview. يرجى تقديم عنوان بريد إلكتروني آخر للاستمرار.',
		provideAnother: 'قدم عنوان بريد إلكتروني آخر',
		duplicated: 'مكرر',
		duplicatedDesc:
			'البريد الإلكتروني المُدخل مرتبط بالفعل بحساب في Tradeview. يرجى تقديم بريد إلكتروني آخر للمتابعة.',
	},

	//validations yup app process
	yup: {
		selectOption: 'يرجى اختيار أحد الخيارات',
		phone: 'لا يمكن كتابة حروف أو رموز في أرقام الهاتف',
		phoneValid: 'يرجى استخدام رقم صالح',
		dateofBirth:
			'رجاء إدخال تاريخ الميلاد بداية برقمين للشهر ورقمين لليوم وأربعة أرقام للعام',
		validEmail: 'يرجى إدخال بريد إلكتروني صالح',
		mustBeAdult:
			'الرجاء إدخال تاريخ ميلاد صالح. يجب أن تكون فوق 18 عامًا للاستمرار',
		passport: 'رجاء ادخال رقم الهوية الخاصة بك',
		passportValid: 'يرجى استخدام رقم صالح',
		passportexpirationdate: 'رجاء إدخال تاريخ صحيح',
		passportexpirationdateValid:
			'يرجى إدخال تاريخ انتهاء صحيح. يتم قبول المستندات الحالية فقط.',
		streetname: 'برجاء ادخال اسم الشارع الخاص بك',
		streetnumber: 'برجاء ادخال رقم الشارع الخاص بك',
		postcode: 'برجاء ادخل الرمز البريدي الخاص بك',
		taxReference:
			'لا يجب أن يضم كودك البريدي أي رموز أو مسافات بين الأحرف والأرقام. برجاء إعادة المحاولة مرة أخرى',
		pepstatus: 'برجاء ادخال المعلومات المطلوبة',
		pepstatusValid: 'تجاوز الحد الأقصى لعدد الأحرف',
		employer: 'برجاء ادخال عملك',
		occupation: 'برجاء إدخال مهنتك',
		employerAddress: 'برجاء ادخل عنوانك الوظيفي',
		employerpostalcode: 'برجاء إدخال الرمز البريدي لعنوانك الوظيفي',
		businesstype: 'برجاء اختيار نوع العمل الخاص بك',
		industry: 'برجاء إدخال مجال عملك',
		business_location: 'برجاء إدخال عنوان العمل',
		business_name: 'برجاء إدخال اسم عملك',
		business_website: 'برجاء إدخال رابط موقعك الإلكتروني',
		bankruptciesdetails: 'يرجى كتابة أي معلومات لديك عن احتمالات حدوث إفلاس',
		acknowledgement:
			'برجاء الضغط على المربع الخاص بإقرار اخلاء المسئولية للمتابعة.',
		agree: 'من فضلك اضغط على المربع لاستكمال الطلب',
		expirationDate: 'تاريخ انتهاء جواز السفر غير صالح',
		invalidEmail: 'تنسيق البريد الإلكتروني غير صالح',
		EmailRequired: 'البريد الإلكتروني مطلوب',
		companyName: 'يرجى إدخال اسم الشركة الأم',
		email: 'برجاء إدخال البريد الإلكتروني للشركة',
		businessDescription: 'لا يمكن الاستمرار في تقديم طلبك',
		required: 'هذه الخانة مطلوبة',
		jobTitle: 'يرجى إدخال مسمى وظيفتك',
		emailAlreadyRegistered:
			'البريد الإلكتروني المدخل مسجل بالفعل. يرجى استخدام بريد إلكتروني آخر.',
	},

	//helper arrays app proces
	array: {
		usd: ' دولار أمريكي',
		eur: ' يورو',
		gbp: ' جنيه إسترليني',
		female: 'أنثي',
		male: 'ذكر',
		noBinary: '',
		other: '',
		noAnswer: '',
		single: 'أعزب',
		married: 'متزوج',
		divorced: 'منفصل',
		windowed: 'أرمل',
		registered: 'شراكة مسجلة',
		yes: 'نعم',
		no: 'لا',
		employed: 'موظف',
		selfEmployed: 'تعمل لحسابك الخاص',
		retired: 'متقاعد',
		unemployed: 'لا تعمل',
		aerospaceAndDefense: 'الفضاء الجوي والدفاع',
		agriculture: 'الزراعة',
		automotive: 'السيارات',
		construction: 'البناء',
		consulting: 'الاستشارات',
		eCommerce: 'التجارة الإلكترونية',
		education: 'التعليم',
		energyAndUtilities: 'الطاقة والمرافق',
		entertainmentAndMedia: 'الترفيه والإعلام',
		fashionAndApparel: 'الأزياء والملابس',
		financeAndBanking: 'المال والبنوك',
		foodAndBeverage: 'الأغذية والمشروبات',
		government: 'الحكومة',
		healthAndWellness: 'الصحة',
		hospitality: 'الضيافة',
		itTechnology: 'تكنولوجيا المعلومات / التكنولوجيا',
		legalServices: 'الخدمات القانونية',
		manufacturing: 'التصنيع',
		marketingAndAdvertising: 'التسويق والإعلان',
		nonProfitCharity: 'الأعمال الخيرية/ غير الربحية',
		realEstate: 'العقارات',
		retail: 'البيع بالتجزئة',
		benefitCorporation: 'شركة ذات فائدة',
		cooperative: 'تعاونية',
		cooperativeCorporation: 'مؤسسة تعاونية',
		corporation: 'مؤسسة',
		familyOwnedBusiness: 'عمل مملوك للعائلة',
		franchise: 'امتياز تجاري',
		holdingCompany: 'شركة قابضة',
		jointVenture: 'مشروع مشترك',
		llc: 'شركة ذات مسئولية محدودة ',
		lllp: 'شركة محدودة ذات مسئولية محدودة',
		llp: 'شراكة ذات مسؤولية محدودة',
		lp: 'شراكة محدودة',
		nonprofitOrganization: 'منظمة غير ربحية',
		partnership: 'شراكة',
		privateEquityFirm: 'شركة أسهم خاصة',
		professionalCorporation: 'شركة احترافية',
		publiclyTradedCompany: 'شركة مساهمة عامة',
		sCorporation: 'شركة S',
		socialEnterprise: 'مؤسسة اجتماعية',
		soleProprietorship: 'ملكية فردية',
		serviceProvider: 'تقديم الخدمات',
		telecommunications: 'الاتصالات',
		transportationAndLogistics: 'النقل والخدمات اللوجستية',
		apprenticeship: 'تدريب مهني',
		casual: 'تعاقدات',
		contractual: 'موسمية',
		freelance: 'عمل حر',
		fullTime: 'دوام كامل',
		internship: 'فترة تدريب',
		onDemand: 'حسب الطلب',
		outsourcedOrOffshore: 'معار',
		partTime: 'دوام جزئي',
		permanent: 'عمل دائم',
		projectBased: 'بالقطعة',
		regular: 'منتظم',
		seasonal: 'موسمي',
		temporary: 'مؤقت',
		volunteer: 'متطوع',
		benefitCorporation: 'شركة ذات فائدة',
		cooperative: 'تعاونية',
		cooperativeCorporation: 'مؤسسة تعاونية',
		corporation: 'مؤسسة',
		familyOwnedBusiness: 'عمل مملوك للعائلة',
		franchise: 'امتياز تجاري',
		holdingCompany: 'شركة قابضة',
		jointVenture: 'مشروع مشترك',
		limitedLiabilityCompany: 'شركة ذات مسئولية محدودة ',
		limitedLiabilityLimitedPartnership: 'شركة محدودة ذات مسئولية محدودة',
		limitedLiabilityPartnership: 'شراكة ذات مسؤولية محدودة',
		limitedPartnership: 'شراكة محدودة',
		nonprofitOrganization: 'منظمة غير ربحية',
		partnership: 'شراكة',
		privateEquityFirm: 'شركة أسهم خاصة',
		professionalCorporation: 'شركة احترافية',
		publiclyTradedCompany: 'شركة مساهمة عامة',
		sCorporation: 'شركة S',
		socialEnterprise: 'مؤسسة اجتماعية',
		soleProprietorship: 'ملكية فردية',
		below25: 'أقل من 25 ألف دولار',
		between50: 'بين 25 ألف دولار - 50 ألف دولار',
		between100: 'بين 50 ألف دولار - 100 ألف دولار',
		over100: 'أكثر من 100 ألف دولار',

		// CORPORATE
		below50mil: 'أقل من 50,000 دولار أمريكي',
		between100mil: 'بين 50 ألف دولار - 100 ألف دولار',
		between500mil: 'بين 100 - 500 ألف دولار',
		between1000mill: 'بين 500,000 دولار أمريكي و1,000,000 دولار أمريكي',
		over1000mill: 'أكثر من 1,000,000 دولار أمريكي',
		// END CORPORATE

		savingsFromSalary: 'ادخار من الراتب',
		governmentAid: 'مساعدات حكومية',
		sale: 'مبيعات',
		investmentsDividends: 'استثمارات وتوزيعات أرباح',
		incomeFromATrust: 'دخول موثوق',
		letting: 'تركة',
		inheritance: 'ميراث',
		donation: 'هبة',
		loan: 'قرض',
		incomeFromSelfEmployment: 'دخل من العمل الحر',
		parentsPartnerOrOther: 'أهل، شريك أو غيره',
		relativeSupport: 'دعم من قريب',
		hedging: 'التحوط',
		speculation: 'المضاربة',
		longTermInvesting: 'الاستثمار طويل الأجل',
		proprietaryTrading: 'تداول الأملاك',
		drawSignature: 'التوقيع يدويًا',
		uploadSignature: 'تحميل التوقيع',
		neverTraded: 'لم أتداول من قبل',
		zeroToFiveYears: '0-5 سنوات',
		sixToTenYears: '6-10 سنوات',
		overTenYears: 'أكثر من 10 سنوات',
		below50K: 'أقل من 50 ألف دولار',
		between50KTo100K: 'بين 50 ألف دولار - 100 ألف دولار',
		between100KTo500K: 'بين 100 - 500 ألف دولار',
		over500K: 'أكثر من 500 ألف دولار',
		daily: 'يوميًا',
		weekly: 'أسبوعيًا',
		monthly: 'شهريًا',
		quarterly: 'بشكل ربع سنوي',
		semiAnnually: 'بشكل نصف سنوي',
		clientAgreement: 'اتفاقية العميل',
		electronicTradingAgreement: 'اتفاقية التداول الالكتروني',
		riskDisclosure: 'إخلاء المسئولية',
		privacyPolicy: 'سياسة الخصوصية',
		consentToDelivery:
			'الموافقة على تسليم البيانات عبر وسائل الإعلام الإلكترونية',
		commissionAgreement: 'اتفاقية العمولة',
		termsAndConditions: 'الأحكام والشروط',
		swapFreeAccount: 'إقرار الحساب الخالي من المبادلة',
		swapFree: 'نموذج طلب حساب خالٍ من المبادلة',
		forex: 'العملات و السلع و المعادن',
		stocks: 'الأسهم',
		futures: 'العقود الآجلة',
		months: {
			january: 'يناير',

			february: 'شهر فبراير',
			march: 'يمشي',
			april: 'أبريل',
			may: 'يمكن',
			june: 'يونيو',
			july: 'يوليو',
			august: 'أغسطس',
			september: 'سبتمبر',
			october: 'اكتوبر',
			november: 'شهر نوفمبر',
			december: 'ديسمبر',
		},
		passport: 'جواز السفر',
		identityCard: 'البطاقة الشخصية',
		residencePermit: 'تصريح الإقامة',
		driversLicense: 'رخصة القيادة',
		utilityBill: 'فاتورة كهرباء أو مياه',
		bankStatement: ' كشف حساب بنكى',
		certificateResidency: 'شهادة الإقامة',
		today: 'اليوم',
		lastWeek: 'الأسبوع الماضي',
		lastMonth: 'الشهر الماضي',
		last3Months: 'آخر 3 أشهر',
		last6Months: 'آخر 6 أشهر',
		costumPeriod: 'فترة كوستوم',
		lastQuarter: 'الربع الأخير',
		lastSemester: 'الفصل الاخير',
		lastYear: 'العام الماضي',
		step: 'خطوة',
		sell: 'بيع',
		buy: 'شراء',
		transfer: 'تحويل',
		deposit: 'إيداع الأموال',
		withdrawal: 'سحب',
		payout: 'دفع',
		adjustment: 'تعديل',
		live: 'حقيقي',
		demo: 'تجريبي',
	},
	//MFA
	mfa: {
		body: 'بالإضافة إلى كلمة مرورك، قم بإعداد طريقة تحقق ثانوية لجعل حسابك أكثر أمانًا.',
		text: 'عند تفعيل المصادقة الثنائية، ستحتاج إلى إدخال كلمة مرورك بالإضافة إلى رمز التحقق المرسل إلى عنوان بريدك الإلكتروني.',
		turn: 'دور',
		on: 'على',
		off: 'عن',
		confirm: 'تأكيد',
		textTwo: 'هل أنت متأكد أنك تريد تعطيل المصادقة متعددة العوامل (MFA)؟',
		yes: 'نعم',
		no: 'لا',
	},

	progress: {
		title: 'نسبة اكمال الطلب',
		progress1: 'المعلومات الشخصية',
		progress2: 'الإقامة الضريبية',
		progress3: 'المنصة والعملة',
		progress31: 'إعداد الحساب',
		progress4: 'تفاصيل الوظيفة',
		progress5: ' التفاصيل المالية',
		progress6: 'خبرة',
		progress7: 'نوع الهوية',
		progress8: ' إثبات محل الإقامة',
		progress9: ' الإقرار',
		progress91: 'الاتفاقيات و الموافقات الخاصة بالحساب',
		progress10: 'التوقيع',
		progress11: 'الكشف عن المخاطر الإضافية',
		progress12: ' إرسال الطلب',
		progress121: 'استسلام',
		progress13: 'حامل الحساب الثانوي',
		progress131: 'إضافة الشريك الثانوي للحساب',
	},

	btns_: {
		back: 'العودة إلى الخلف',
		continue: 'استمرار',
		cancel: 'إلغاء',
		yesDelete: 'نعم، حذف',
		noDelete: 'لا، العودة إلى الخلف',
		resendInvitations: 'إعادة إرسال الدعوة',
		of: 'ل',
		yesImSure: 'نعم أنا متأكد',
		submit: 'قدّم',
	},

	trading_tools: {
		main_title: 'أدوات التداول الخاصة بك',
		main_desc:
			'اتخذ قرارات أكثر ذكاءً ومبنية على البيانات باستخدام أدوات التداول القوية لدينا، المصممة لمنحك الأفضلية في السوق.',
		calculatorSuite: 'مجموعة الآلات الحاسبة',
		calculatorSuiteDesc:
			'استعد بجميع الأدوات الأساسية للتداول الاستراتيجي! تم تصميم هذه المجموعة القوية لتمكينك وكشف إمكانياتك بغض النظر عن مستوى تداولك.',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'احصل على موارد مجانية تركز على النمو مثل الدردشة المباشرة مع المتداولين والخبراء، البث المباشر، وأخبار السوق اللحظية لتتمكن من التنقل في الأسواق بثقة.',
		surfsup: 'Surf’s Up!',
		surfsupDesc:
			'ابق على اطلاع على آخر تطورات السوق واستكشف استراتيجيات ورؤى وتحليلات جديدة.',
	},

	disclaimer: {
		secure1: 'معاملات الامان والتشفير',
		secure2: '',
		secure3: '',
		term: 'الشروط والأحكام',
		privacy: 'سياسة الخصوصية',
		aml: 'سياسة مكافحة غسيل الاموال',
		withdrawal: 'سياسات السحب',
		refund: 'سياسات استرداد الأموال',
		risk: 'إخلاء المسئولية',
		title: 'إخلاء المسئولية',
		default: {
			description:
				'لا تقدم .Tradeview Financial Markets خدماتها ومنتجاتها داخل الولايات المتحدة، كما أنها ليست متاحة للأمريكيين، على النحو المحدد بموجب قانون الولايات المتحدة الأمريكية. إن المعلومات الواردة في هذا الموقع غير موجهة إلى المقيمين في أي بلد يحظر تداول العملات الأجنبية و/أو عقود الفروقات، بموجب القوانين والتشريعات المحلية. CFDs هي أدوات معقدة وتنطوي على مخاطر عالية بخسارة المال بسرعة بسبب الرافعة المالية. بين 74% - 89% من حسابات المستثمرين الأفراد تخسر المال عند تداول عقود الفروقات. يجب عليك أن تأخذ بعين الاعتبار ما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كنت تستطيع تحمل المخاطر العالية بفقدان أموالك.',
		},
		ltd: {
			description:
				'The services and products offered by Tradeview Ltd. are not being offered within the United States (US) and are not being offered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		},
		latam: {
			description:
				'لا تقدم .Tradeview Financial Markets S.A.C خدماتها ومنتجاتها داخل الولايات المتحدة، كما أنها ليست متاحة للأمريكيين، على النحو المحدد بموجب قانون الولايات المتحدة الأمريكية. إن المعلومات الواردة في هذا الموقع غير موجهة إلى المقيمين في أي بلد يحظر تداول العملات الأجنبية و/أو عقود الفروقات، بموجب القوانين والتشريعات المحلية. CFDs هي أدوات معقدة وتنطوي على مخاطر عالية بخسارة المال بسرعة بسبب الرافعة المالية. بين 74% - 89% من حسابات المستثمرين الأفراد تخسر المال عند تداول عقود الفروقات. يجب عليك أن تأخذ بعين الاعتبار ما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كنت تستطيع تحمل المخاطر العالية بفقدان أموالك.',
		},
		mena: {
			description:
				'لا تقدم .Tradeview Financial Markets S.A.C خدماتها ومنتجاتها داخل الولايات المتحدة، كما أنها ليست متاحة للأمريكيين، على النحو المحدد بموجب قانون الولايات المتحدة الأمريكية. إن المعلومات الواردة في هذا الموقع غير موجهة إلى المقيمين في أي بلد يحظر تداول العملات الأجنبية و/أو عقود الفروقات، بموجب القوانين والتشريعات المحلية. CFDs هي أدوات معقدة وتنطوي على مخاطر عالية بخسارة المال بسرعة بسبب الرافعة المالية. بين 74% - 89% من حسابات المستثمرين الأفراد تخسر المال عند تداول عقود الفروقات. يجب عليك أن تأخذ بعين الاعتبار ما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كنت تستطيع تحمل المخاطر العالية بفقدان أموالك.',
		},
	},
	authErrors: {
		default: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقًا.',

		register: {
			usernameExists:
				'هذا الأيميل مسجل بالفعل. رجاء الدخول علي لوحه التحكم أو أستخدام أيميل اخر',
			invalidPassword:
				'يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف إنجليزية على الأقل تتضمن حرفًا صغيرًا، حرفًا كبيرًا، رقمًا، وحرفًا خاصًا واحدًا على الأقل.',
			invalidParameter:
				'بعض التفاصيل غير صحيحه أو غير موجوده. رجاء التأكد من صحه المعلومات و المحاوله مره اخري',
			aliasExists:
				'رقم الهافت او الأيميل مسجل بالفعل مع حساب أخر. رجاء الدخول علي الحساب المسجل بالفعل أو استخدام معلومات دخول أخري',
			limitExceeded:
				'تم طلب عده أكواد تأكيد في وقت قصير. رجاء الانتظار قليلا ثم معاوده المحاوله مره أخري',
			notAuthorized:
				'لم نتمكن من أتمام عمليه الدخول بسبب فشل التحقق في الوقت الحالي. رجاء المحاوله مره اخري في وقت لاحق',
			codeMismatch:
				'كود التأكيد غير صحيح. راجاء التأكد منه و المحاوله مره أخري ',
		},

		login: {
			userNotFound:
				'الايميل المستخدم غير مسجل. رجاء التأكد من صحه الأيميل أو سجل لطلب فتح حساب جديد',
			notAuthorized:
				'لم ينجح تسجيل الدخول. يُرجى التحقق من بيانات الدخول والمحاولة مرة أخرى. إذا استمرت المشكلة، يُرجى التواصل معنا.',
			invalidPassword:
				'بيانات الدخول غير صحيحة. يُرجى التحقق والمحاولة مرة أخرى.',
			codeMismatch: 'الرمز المدخل غير صحيح. يُرجى التحقق والمحاولة مرة أخرى.',
			userNotConfirmed:
				'قم بتأكيد حسابك لتسجيل الدخول. يرجى التحقق من بريدك الإلكتروني أو هاتفك للحصول على رمز التحقق',
			passwordResetRequired:
				'يرجى إعادة تعيين كلمة المرور الخاصة بك قبل تسجيل الدخول. اتبع تعليمات إعادة التعيين المرسلة إلى بريدك الإلكتروني',
			expiredCode:
				'انتهت صلاحية كود التأكيد . رجاء طلب كود جديد و المحاولة مرة أخرى',
		},

		resetPass: {
			userNotFound:
				'عنوان البريد الالكتروني المدخل غير مسجل معنا . رجاء التاكد من صحة الايميل او التسجيل لحساب جديد.',
			invalidParameter:
				'بعض البيانات المطلوبة غير صحيحة أو مفقودة. يُرجى مراجعة معلوماتك والمحاولة مرة أخرى.',
			notAuthorized:
				'فشلت عملية المصادقة . يُرجى المحاولة مرة أخرى أو التواصل معنا.',
			limitExceeded:
				'محاولات إعادة تعيين كلمة المرور كثيرة جدًا. يُرجى الانتظار قليلًا والمحاولة مرة أخرى.',
			internalError: 'لم نتمكن من اتمام طلبك. رجاء المحاولة مرة اخرى',
			invalidLambda: 'لم نتمكن من اتمام طلبك. رجاء المحاولة مرة اخرى',
			invalidSmsPolicy:
				'لم نتمكن من ارسال رسالة نصية للمصادقة. رجاء المحاولة مرة اخرى',
			codeMismatch:
				'كود التأكيد المدخل غير صحيح . رجاء طلب كود جديد و المحاولة مرة أخرى',
			expiredCode:
				'انتهت صلاحية كود التأكيد المدخل . رجاء طلب كود جديد و المحاولة مرة أخرى',
			invalidPassword:
				'يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف إنجليزية على الأقل تتضمن حرفًا صغيرًا، حرفًا كبيرًا، رقمًا، وحرفًا خاصًا واحدًا على الأقل.',
		},
	},
}
